/**
 * 씨앤텍차이나 다국어 번역 데이터
 * KR: 한국어, EN: 영어, CH: 중국어
 *
 * 이 파일은 import-i18n-excel.mjs 스크립트로 자동 생성되었습니다.
 * 수정이 필요한 경우:
 * 1. cntechchina_i18n_template.xlsx 엑셀 파일을 수정
 * 2. node import-i18n-excel.mjs <수정된엑셀파일.xlsx> 실행
 */

export const translations = {
  menu: {
    cntechchina: {
      KR: "씨앤텍차이나",
      EN: "C&Tech China",
      CH: "科特琪化妆品（苏州）有限公司"
    },
    codeManage: {
      KR: "자재코드관리",
      EN: "Material Code Management",
      CH: "物流编码管理"
    },
    holiday: {
      KR: "중국 공휴일",
      EN: "Holiday",
      CH: "中国节假日"
    },
    sampleControl: {
      KR: "샘플 관리",
      EN: "Sample Control",
      CH: "打样记录"
    },
    deliveryMonitoring: {
      KR: "납기 모니터링",
      EN: "Delivery Monitoring",
      CH: "交期监控"
    }
  },
  codeManage: {
    pageTitle: {
      KR: "자재코드관리",
      EN: "Material Code Management",
      CH: "物流编码管理"
    },
    search: {
      placeholder: {
        KR: "검색어 입력 (코드, 제품명, 공급상)",
        EN: "Search (Code, Product Name, Supplier)",
        CH: "搜索 (编码、产品名、供应商)"
      },
      searchBtn: {
        KR: "검색",
        EN: "Search",
        CH: "搜索"
      },
      resetBtn: {
        KR: "초기화",
        EN: "Reset",
        CH: "初始化"
      }
    },
    actions: {
      totalCount: {
        KR: "총 {count}건",
        EN: "Total {count}",
        CH: "总计 {count} 件"
      },
      newItem: {
        KR: "신규 등록",
        EN: "New Item",
        CH: "新注册"
      },
      excelDownload: {
        KR: "엑셀 다운로드",
        EN: "Excel Download",
        CH: "下载Excel"
      },
      downloading: {
        KR: "다운로드 중...",
        EN: "Downloading...",
        CH: "下载中..."
      },
      sendNotification: {
        KR: "신규코드 통지",
        EN: "New Code Notification",
        CH: "新代码通知"
      }
    },
    table: {
      no: {
        KR: "No",
        EN: "No",
        CH: "序号"
      },
      category: {
        KR: "분류",
        EN: "Category",
        CH: "分类"
      },
      hqCode: {
        KR: "본사코드",
        EN: "HQ Code",
        CH: "总部编码"
      },
      hqProductName: {
        KR: "본사제품명",
        EN: "HQ Product Name",
        CH: "总部产品名"
      },
      sapProductName: {
        KR: "SAP 제품명",
        EN: "SAP Product Name",
        CH: "SAP产品名"
      },
      chinaCode: {
        KR: "중국코드",
        EN: "China Code",
        CH: "中国编码"
      },
      chinaProductName: {
        KR: "중국제품명",
        EN: "China Product Name",
        CH: "中国产品名"
      },
      exportPriceSplit: {
        KR: "수출단가분할($)",
        EN: "Export Price Split($)",
        CH: "出口单价分割($)"
      },
      exportPrice: {
        KR: "수출단가($)",
        EN: "Export Price($)",
        CH: "出口单价($)"
      },
      exportPriceCny: {
        KR: "수출단가(¥)",
        EN: "Export Price(¥)",
        CH: "出口单价(¥)"
      },
      supplier: {
        KR: "공급상",
        EN: "Supplier",
        CH: "供应商"
      },
      supplyPriceSplit: {
        KR: "공급가분할(¥)",
        EN: "Supply Price Split(¥)",
        CH: "供应价分割(¥)"
      },
      supplyPrice: {
        KR: "공급가(¥)",
        EN: "Supply Price(¥)",
        CH: "供应价(¥)"
      },
      vatIncludedPriceSplit: {
        KR: "증치세포함가분할(¥)",
        EN: "VAT Incl. Price Split(¥)",
        CH: "含增值税价分割(¥)"
      },
      vatIncludedPrice: {
        KR: "증치세포함가(¥)",
        EN: "VAT Incl. Price(¥)",
        CH: "含增值税价(¥)"
      },
      spec: {
        KR: "Spec",
        EN: "Spec",
        CH: "规格"
      },
      created: {
        KR: "생성날짜",
        EN: "Created Date",
        CH: "创建日期"
      },
      actions: {
        KR: "액션",
        EN: "Actions",
        CH: "操作"
      }
    },
    modal: {
      titleCreate: {
        KR: "신규 자재코드 등록",
        EN: "New Material Code",
        CH: "新增物流编码"
      },
      titleEdit: {
        KR: "자재코드 수정",
        EN: "Edit Material Code",
        CH: "编辑物流编码"
      },
      titleView: {
        KR: "자재코드 상세",
        EN: "Material Code Details",
        CH: "物流编码详情"
      },
      sectionExport: {
        KR: "수출 단가 정보 ($)",
        EN: "Export Price Info ($)",
        CH: "出口价格信息 ($)"
      },
      sectionSupply: {
        KR: "공급 가격 정보 (¥)",
        EN: "Supply Price Info (¥)",
        CH: "供应价格信息 (¥)"
      },
      specPlaceholder: {
        KR: "제품 스펙 정보",
        EN: "Product Spec Info",
        CH: "产品规格信息"
      },
      close: {
        KR: "닫기",
        EN: "Close",
        CH: "关闭"
      },
      cancel: {
        KR: "취소",
        EN: "Cancel",
        CH: "取消"
      },
      edit: {
        KR: "수정",
        EN: "Edit",
        CH: "编辑"
      },
      save: {
        KR: "저장",
        EN: "Save",
        CH: "保存"
      },
      register: {
        KR: "등록",
        EN: "Register",
        CH: "登录"
      },
      supplierSearch:  { KR: "입력해서 찾기", EN: "Type to search",  CH: "输入以搜索" },
      supplierNoHit:   { KR: "찾는 공급상이 없습니다", EN: "No matching supplier", CH: "没有匹配的供应商" },
      repImage:        { KR: "대표사진",      EN: "Main Photo",      CH: "代表图片" },
      noPhoto:         { KR: "사진 없음",     EN: "No Photo",        CH: "无图片" },
      changePhoto:     { KR: "사진 변경",     EN: "Change Photo",    CH: "更换图片" },
      selectPhoto:     { KR: "사진 선택",     EN: "Select Photo",    CH: "选择图片" },
      attachment:      { KR: "첨부파일",      EN: "Attachments",     CH: "附件" },
      noAttachment:    { KR: "첨부파일 없음", EN: "No Attachments",  CH: "无附件" },
      poHistory: {
        title:     { KR: "구매오더 히스토리", EN: "Purchase Order History", CH: "采购订单历史" },
        orderId:          { KR: "오더 ID",   EN: "Order ID",           CH: "订单编号" },
        date:             { KR: "오더일",    EN: "Order Date",         CH: "订单日期" },
        quantity:         { KR: "수량",      EN: "Qty",                CH: "数量" },
        exportPrice:      { KR: "수출단가",   EN: "Export Price",       CH: "出口单价" },
        unitPrice:        { KR: "내수단가",  EN: "Domestic Price",     CH: "内销单价" },
        total:            { KR: "총액",      EN: "Total",              CH: "总额" },
        noData:           { KR: "구매오더 내역이 없습니다", EN: "No purchase order history", CH: "暂无采购订单历史" },
        loading:          { KR: "로딩 중...", EN: "Loading...",         CH: "加载中..." }
      }
    },
    pagination: {
      itemsPerPage: {
        KR: "{count}개씩",
        EN: "{count} per page",
        CH: "每页 {count} 条"
      },
      prev: {
        KR: "이전",
        EN: "Prev",
        CH: "上一页"
      },
      next: {
        KR: "다음",
        EN: "Next",
        CH: "下一页"
      }
    },
    messages: {
      loading: {
        KR: "자재코드 목록을 불러오는 중입니다...",
        EN: "Loading material codes...",
        CH: "正在加载物流编码..."
      },
      noData: {
        KR: "자재코드 정보가 없습니다",
        EN: "No material codes found",
        CH: "暂无物流编码"
      },
      created: {
        KR: "자재코드가 등록되었습니다.",
        EN: "Material code has been registered.",
        CH: "物流编码已登记。"
      },
      updated: {
        KR: "자재코드가 수정되었습니다.",
        EN: "Material code has been updated.",
        CH: "物流编码已更新。"
      },
      deleted: {
        KR: "자재코드가 삭제되었습니다.",
        EN: "Material code has been deleted.",
        CH: "物流编码已删除。"
      },
      deleteConfirm: {
        KR: "\"{code}\" 자재코드를 삭제하시겠습니까?",
        EN: "Are you sure you want to delete material code \"{code}\"?",
        CH: "确定要删除物流编码 \"{code}\" 吗？"
      },
      saveFailed: {
        KR: "저장 실패",
        EN: "Save failed",
        CH: "保存失败"
      },
      loadFailed: {
        KR: "데이터 조회 실패",
        EN: "Failed to load data",
        CH: "数据加载失败"
      },
      exportFailed: {
        KR: "엑셀 다운로드 실패",
        EN: "Excel download failed",
        CH: "Excel下载失败"
      }
    },
    excel: {
      fileName: {
        KR: "자재코드",
        EN: "MaterialCodes",
        CH: "物流编码"
      },
      sheetName: {
        KR: "자재코드",
        EN: "MaterialCodes",
        CH: "物流编码"
      }
    }
  },
  priceManage: {
    pageTitle: {
      KR: "단가관리",
      EN: "Price Management",
      CH: "单价管理"
    },
    search: {
      placeholder: {
        KR: "검색어 입력 (본사코드, 제품군명)",
        EN: "Search (HQ Code, Product Name)",
        CH: "搜索 (总部编码、产品群名)"
      },
      searchBtn: {
        KR: "검색",
        EN: "Search",
        CH: "搜索"
      },
      resetBtn: {
        KR: "초기화",
        EN: "Reset",
        CH: "初始化"
      }
    },
    actions: {
      totalCount: {
        KR: "총 {count}건",
        EN: "Total {count}",
        CH: "总计 {count} 件"
      },
      newItem: {
        KR: "신규 등록",
        EN: "New Item",
        CH: "新注册"
      },
      excelDownload: {
        KR: "엑셀 다운로드",
        EN: "Excel Download",
        CH: "下载Excel"
      },
      downloading: {
        KR: "다운로드 중...",
        EN: "Downloading...",
        CH: "下载中..."
      }
    },
    table: {
      no: {
        KR: "No",
        EN: "No",
        CH: "序号"
      },
      headCode: {
        KR: "본사코드",
        EN: "HQ Code",
        CH: "总部编码"
      },
      productGroup: {
        KR: "제품군명",
        EN: "Product Group",
        CH: "产品群名"
      },
      priceName: {
        KR: "제품명",
        EN: "Product Name",
        CH: "产品名"
      },
      qtyFrom: {
        KR: "수량(From)",
        EN: "Qty(From)",
        CH: "数量(From)"
      },
      qtyTo: {
        KR: "수량(To)",
        EN: "Qty(To)",
        CH: "数量(To)"
      },
      exportPrice: {
        KR: "수출단가($)",
        EN: "Export Price($)",
        CH: "出口单价($)"
      },
      supplyPrice: {
        KR: "공급가(¥)",
        EN: "Supply Price(¥)",
        CH: "供应价(¥)"
      },
      vatIncludedPrice: {
        KR: "부가세포함가(¥)",
        EN: "VAT Incl. Price(¥)",
        CH: "含增值税价(¥)"
      },
      createdAt: {
        KR: "등록일",
        EN: "Created",
        CH: "登录日期"
      },
      actions: {
        KR: "액션",
        EN: "Actions",
        CH: "操作"
      }
    },
    modal: {
      titleCreate: {
        KR: "신규 단가 등록",
        EN: "New Price",
        CH: "新增单价"
      },
      titleEdit: {
        KR: "단가 수정",
        EN: "Edit Price",
        CH: "编辑单价"
      },
      titleView: {
        KR: "단가 상세",
        EN: "Price Details",
        CH: "单价详情"
      },
      sectionQty: {
        KR: "수량 범위",
        EN: "Quantity Range",
        CH: "数量范围"
      },
      sectionPrice: {
        KR: "단가 정보",
        EN: "Price Info",
        CH: "单价信息"
      },
      close: {
        KR: "닫기",
        EN: "Close",
        CH: "关闭"
      },
      cancel: {
        KR: "취소",
        EN: "Cancel",
        CH: "取消"
      },
      edit: {
        KR: "수정",
        EN: "Edit",
        CH: "编辑"
      },
      save: {
        KR: "저장",
        EN: "Save",
        CH: "保存"
      },
      register: {
        KR: "등록",
        EN: "Register",
        CH: "登录"
      },
      delete: {
        KR: "삭제",
        EN: "Delete",
        CH: "删除"
      }
    },
    pagination: {
      itemsPerPage: {
        KR: "{count}개씩",
        EN: "{count} per page",
        CH: "每页 {count} 条"
      },
      prev: {
        KR: "이전",
        EN: "Prev",
        CH: "上一页"
      },
      next: {
        KR: "다음",
        EN: "Next",
        CH: "下一页"
      }
    },
    messages: {
      loading: {
        KR: "단가 목록을 불러오는 중입니다...",
        EN: "Loading prices...",
        CH: "正在加载单价..."
      },
      noData: {
        KR: "단가 정보가 없습니다",
        EN: "No prices found",
        CH: "暂无单价"
      },
      created: {
        KR: "단가가 등록되었습니다.",
        EN: "Price has been registered.",
        CH: "单价已登记。"
      },
      updated: {
        KR: "단가가 수정되었습니다.",
        EN: "Price has been updated.",
        CH: "单价已更新。"
      },
      deleted: {
        KR: "단가가 삭제되었습니다.",
        EN: "Price has been deleted.",
        CH: "单价已删除。"
      },
      deleteConfirm: {
        KR: "\"{code}\" 단가를 삭제하시겠습니까?",
        EN: "Are you sure you want to delete price \"{code}\"?",
        CH: "确定要删除单价 \"{code}\" 吗？"
      },
      saveFailed: {
        KR: "저장 실패",
        EN: "Save failed",
        CH: "保存失败"
      },
      loadFailed: {
        KR: "데이터 조회 실패",
        EN: "Failed to load data",
        CH: "数据加载失败"
      },
      exportFailed: {
        KR: "엑셀 다운로드 실패",
        EN: "Excel download failed",
        CH: "Excel下载失败"
      },
      codeRequired: {
        KR: "본사코드를 입력해주세요.",
        EN: "Please enter HQ code.",
        CH: "请输入总部编码。"
      }
    },
    excel: {
      fileName: {
        KR: "단가DB",
        EN: "PriceDB",
        CH: "单价DB"
      },
      sheetName: {
        KR: "단가",
        EN: "Prices",
        CH: "单价"
      }
    }
  },
  supplierManage: {
    pageTitle: {
      KR: "공급처관리",
      EN: "Supplier Management",
      CH: "供应商管理"
    },
    search: {
      placeholder: {
        KR: "검색어 입력 (공급처명, 담당자, 연락처)",
        EN: "Search (Supplier, Contact, Phone)",
        CH: "搜索 (供应商名、担当人、联系电话)"
      },
      searchBtn: {
        KR: "검색",
        EN: "Search",
        CH: "搜索"
      },
      resetBtn: {
        KR: "초기화",
        EN: "Reset",
        CH: "初始化"
      }
    },
    actions: {
      totalCount: {
        KR: "총 {count}건",
        EN: "Total {count}",
        CH: "总计 {count} 件"
      },
      newItem: {
        KR: "신규 등록",
        EN: "New Item",
        CH: "新注册"
      },
      excelDownload: {
        KR: "엑셀 다운로드",
        EN: "Excel Download",
        CH: "下载Excel"
      },
      downloading: {
        KR: "다운로드 중...",
        EN: "Downloading...",
        CH: "下载中..."
      }
    },
    table: {
      no: {
        KR: "No",
        EN: "No",
        CH: "序号"
      },
      supplierNameBr: {
        KR: "공급상",
        EN: "Brand",
        CH: "供应商"
      },
      supplierNameCn: {
        KR: "공급처",
        EN: "Supplier",
        CH: "供应商(全称)"
      },
      supplierNameKr: {
        KR: "공급처(한글)",
        EN: "Supplier(Korean)",
        CH: "供应商(韩语)"
      },
      legalRepresentative: {
        KR: "대표자",
        EN: "CEO",
        CH: "法定代表人"
      },
      registeredCapital: {
        KR: "자본금(万)",
        EN: "Capital(万)",
        CH: "注册资本(万)"
      },
      address: {
        KR: "주소",
        EN: "Address",
        CH: "住所"
      },
      establishedDate: {
        KR: "설립일",
        EN: "Est.",
        CH: "成立日期"
      },
      employeeCount: {
        KR: "종업원수",
        EN: "Employee",
        CH: "人员数"
      },
      categoryMain: {
        KR: "대분류",
        EN: "Category",
        CH: "大分类"
      },
      categorySub: {
        KR: "소분류",
        EN: "Category Sub",
        CH: "小分类"
      },
      contactPerson: {
        KR: "담당자",
        EN: "Contact",
        CH: "担当人"
      },
      contactPhone: {
        KR: "연락처",
        EN: "Phone",
        CH: "联系电话"
      },
      email: {
        KR: "이메일",
        EN: "Email",
        CH: "邮箱"
      },
      website: {
        KR: "홈페이지",
        EN: "Homepage",
        CH: "网站"
      },
      registeredDate: {
        KR: "등록일",
        EN: "Register",
        CH: "登陆日期"
      },
      remarks: {
        KR: "비고",
        EN: "Remarks",
        CH: "备注"
      },
      actions: {
        KR: "액션",
        EN: "Actions",
        CH: "操作"
      }
    },
    modal: {
      titleCreate: {
        KR: "신규 공급처 등록",
        EN: "New Supplier",
        CH: "新增供应商"
      },
      titleEdit: {
        KR: "공급처 수정",
        EN: "Edit Supplier",
        CH: "编辑供应商"
      },
      titleView: {
        KR: "공급처 상세",
        EN: "Supplier Details",
        CH: "供应商详情"
      },
      sectionCategory: {
        KR: "분류 정보",
        EN: "Category Info",
        CH: "分类信息"
      },
      sectionContact: {
        KR: "연락처 정보",
        EN: "Contact Info",
        CH: "联系方式"
      },
      close: {
        KR: "닫기",
        EN: "Close",
        CH: "关闭"
      },
      cancel: {
        KR: "취소",
        EN: "Cancel",
        CH: "取消"
      },
      edit: {
        KR: "수정",
        EN: "Edit",
        CH: "编辑"
      },
      save: {
        KR: "저장",
        EN: "Save",
        CH: "保存"
      },
      register: {
        KR: "등록",
        EN: "Register",
        CH: "登录"
      },
      delete: {
        KR: "삭제",
        EN: "Delete",
        CH: "删除"
      }
    },
    pagination: {
      itemsPerPage: {
        KR: "{count}개씩",
        EN: "{count} per page",
        CH: "每页 {count} 条"
      },
      prev: {
        KR: "이전",
        EN: "Prev",
        CH: "上一页"
      },
      next: {
        KR: "다음",
        EN: "Next",
        CH: "下一页"
      }
    },
    messages: {
      loading: {
        KR: "공급처 목록을 불러오는 중입니다...",
        EN: "Loading suppliers...",
        CH: "正在加载供应商..."
      },
      noData: {
        KR: "공급처 정보가 없습니다",
        EN: "No suppliers found",
        CH: "暂无供应商"
      },
      created: {
        KR: "공급처가 등록되었습니다.",
        EN: "Supplier has been registered.",
        CH: "供应商已登记。"
      },
      updated: {
        KR: "공급처가 수정되었습니다.",
        EN: "Supplier has been updated.",
        CH: "供应商已更新。"
      },
      deleted: {
        KR: "공급처가 삭제되었습니다.",
        EN: "Supplier has been deleted.",
        CH: "供应商已删除。"
      },
      deleteConfirm: {
        KR: "\"{name}\" 공급처를 삭제하시겠습니까?",
        EN: "Are you sure you want to delete supplier \"{name}\"?",
        CH: "确定要删除供应商 \"{name}\" 吗？"
      },
      saveFailed: {
        KR: "저장 실패",
        EN: "Save failed",
        CH: "保存失败"
      },
      loadFailed: {
        KR: "데이터 조회 실패",
        EN: "Failed to load data",
        CH: "数据加载失败"
      },
      exportFailed: {
        KR: "엑셀 다운로드 실패",
        EN: "Excel download failed",
        CH: "Excel下载失败"
      },
      nameRequired: {
        KR: "공급처명(중문)을 입력해주세요.",
        EN: "Please enter supplier name (Chinese).",
        CH: "请输入供应商全称。"
      }
    },
    excel: {
      fileName: {
        KR: "공급처DB",
        EN: "SupplierDB",
        CH: "供应商DB"
      },
      sheetName: {
        KR: "공급처",
        EN: "Suppliers",
        CH: "供应商"
      }
    }
  },
  language: {
    label: {
      KR: "언어",
      EN: "Language",
      CH: "语言"
    },
    options: {
      KR: "한국어",
      EN: "English",
      CH: "中文"
    }
  },
  codeNotification: {
    title: {
      KR: "신규코드 통지",
      EN: "New Code Notification",
      CH: "新代码通知"
    },
    step1: {
      KR: "코드 선택",
      EN: "Select Codes",
      CH: "选择代码"
    },
    step2: {
      KR: "이메일 작성",
      EN: "Compose Email",
      CH: "编写电子邮件"
    },
    dateRange: {
      KR: "생성날짜 범위",
      EN: "Created Date Range",
      CH: "创建日期范围"
    },
    search: {
      KR: "검색",
      EN: "Search",
      CH: "搜索"
    },
    loading: {
      KR: "로딩 중...",
      EN: "Loading...",
      CH: "加载中..."
    },
    noData: {
      KR: "데이터가 없습니다",
      EN: "No data",
      CH: "无数据"
    },
    selectAll: {
      KR: "전체 선택",
      EN: "Select All",
      CH: "全选"
    },
    created: {
      KR: "생성날짜",
      EN: "Created",
      CH: "创建日期"
    },
    category: {
      KR: "분류",
      EN: "Category",
      CH: "分类"
    },
    hqCode: {
      KR: "본사코드",
      EN: "HQ Code",
      CH: "总部代码"
    },
    hqProductName: {
      KR: "본사제품명",
      EN: "HQ Product Name",
      CH: "总部产品名称"
    },
    chinaCode: {
      KR: "중국코드",
      EN: "China Code",
      CH: "中国代码"
    },
    chinaProductName: {
      KR: "중국제품명",
      EN: "China Product Name",
      CH: "中国产品名称"
    },
    exportPrice: {
      KR: "수출단가",
      EN: "Export Price",
      CH: "出口价格"
    },
    supplier: {
      KR: "공급상",
      EN: "Supplier",
      CH: "供应商"
    },
    vatIncludedPrice: {
      KR: "증치세포함가(¥)",
      EN: "VAT Incl. Price(¥)",
      CH: "含增值税价(¥)"
    },
    senderName: {
      KR: "발신인 이름",
      EN: "Sender Name",
      CH: "发件人姓명"
    },
    senderNamePlaceholder: {
      KR: "발신인 이름을 입력하세요",
      EN: "Enter sender name",
      CH: "请输入发件人姓名"
    },
    recipients: {
      KR: "수신인",
      EN: "Recipients",
      CH: "收件人"
    },
    emailPlaceholder: {
      KR: "email@example.com",
      EN: "email@example.com",
      CH: "email@example.com"
    },
    namePlaceholder: {
      KR: "이름 (선택)",
      EN: "Name (optional)",
      CH: "姓名（可选）"
    },
    searchEmployee: {
      KR: "직원 검색",
      EN: "Search Employee",
      CH: "搜索员工"
    },
    addRecipient: {
      KR: "수신인 추가",
      EN: "Add Recipient",
      CH: "添加收件人"
    },
    subject: {
      KR: "제목",
      EN: "Subject",
      CH: "主题"
    },
    subjectPlaceholder: {
      KR: "이메일 제목을 입력하세요",
      EN: "Enter email subject",
      CH: "请输入电子邮件主题"
    },
    message: {
      KR: "본문",
      EN: "Message",
      CH: "正文"
    },
    messagePlaceholder: {
      KR: "추가 메시지를 입력하세요 (선택)",
      EN: "Enter additional message (optional)",
      CH: "请输入附加消息（可选）"
    },
    selectedCodes: {
      KR: "선택된 코드",
      EN: "Selected Codes",
      CH: "已选代码"
    },
    back: {
      KR: "이전",
      EN: "Back",
      CH: "返回"
    },
    cancel: {
      KR: "취소",
      EN: "Cancel",
      CH: "取消"
    },
    next: {
      KR: "다음",
      EN: "Next",
      CH: "下一步"
    },
    send: {
      KR: "발송",
      EN: "Send",
      CH: "发送"
    },
    sending: {
      KR: "발송 중...",
      EN: "Sending...",
      CH: "发送中..."
    },
    employeeSearchPlaceholder: {
      KR: "직원 이름 검색",
      EN: "Search employee name",
      CH: "搜索员工姓名"
    },
    noEmployees: {
      KR: "검색 결과가 없습니다",
      EN: "No results",
      CH: "无搜索结果"
    },
    selectCodesFirst: {
      KR: "먼저 코드를 선택해주세요",
      EN: "Please select codes first",
      CH: "请先选择代码"
    },
    sendSuccess: {
      KR: "이메일이 발송되었습니다",
      EN: "Email sent successfully",
      CH: "电子邮件已发送"
    },
    sendError: {
      KR: "이메일 발송에 실패했습니다",
      EN: "Failed to send email",
      CH: "发送电子邮件失败"
    }
  },
  poManagement: {
    orderNo: { KR: "구매오더", EN: "Purchase order", CH: "采购订单" },
    sampleLabel: { KR: "샘플비 차감", EN: "Sample deduction", CH: "打样费用抵扣" },
    sampleMustDeduct: { KR: "지급 시 샘플비 ¥{amount}을(를) 반드시 차감하고 지급하세요. (발주서 금액에는 포함되어 있지 않습니다)", EN: "Be sure to deduct the sample cost ¥{amount} when paying. (It is not deducted in the PO amount.)", CH: "付款时务必扣除打样费用 ¥{amount} 后再支付。（订单金额中未扣除）" },
    sampleTitle: { KR: "샘플", EN: "Sample", CH: "打样" },
    sampleNotFound: { KR: "샘플을 찾지 못했습니다.", EN: "Sample not found.", CH: "未找到打样。" },
    sampleProduct: { KR: "제품", EN: "Product", CH: "产品" },
    sampleCapacity: { KR: "용량", EN: "Capacity", CH: "容量" },
    sampleSupplier: { KR: "공급상", EN: "Supplier", CH: "供应商" },
    samplePerson: { KR: "담당", EN: "In charge", CH: "担当" },
    samplePeriod: { KR: "기간", EN: "Period", CH: "时间" },
    sampleProgress: { KR: "진행", EN: "Progress", CH: "打样进度" },
    sampleCost: { KR: "샘플비", EN: "Sample cost", CH: "打样费用" },
    sampleIssues: { KR: "문제점", EN: "Issues", CH: "打样问题点" },
    sampleRequirement: { KR: "요구사항", EN: "Requirement", CH: "要求" },
    sampleLink: { KR: "샘플 연결", EN: "Link samples", CH: "关联打样" },
    sampleLinkTitle: { KR: "샘플비 차감 연결", EN: "Link sample deductions", CH: "关联打样费用抵扣" },
    sampleLinkHint: { KR: "이 발주서 공급상의 샘플 중 비용처리가 미정산이고 다른 발주서에 차감되지 않은 것입니다. 발주 금액은 바뀌지 않으며, 최종승인 뒤에도 바꿀 수 있습니다.", EN: "Unsettled samples of this PO's supplier that are not deducted on another PO. The PO amount does not change; can be changed even after final approval.", CH: "本订单供应商的、费用处理为未结算且未在其他订单抵扣的打样。订单金额不变，终审后也可修改。" },
    sampleColNo: { KR: "번호", EN: "No.", CH: "编号" },
    sampleColImage: { KR: "사진", EN: "Photo", CH: "图片" },
    sampleColStart: { KR: "시작일", EN: "Start", CH: "开始时间" },
    sampleLinkNone: { KR: "연결할 샘플이 없습니다.", EN: "No samples to link.", CH: "没有可关联的打样。" },
    sampleLinkTotal: { KR: "샘플비 합계", EN: "Sample cost total", CH: "打样费用合计" },
    sampleLinkSave: { KR: "저장", EN: "Save", CH: "保存" },
    sampleLinkCancel: { KR: "취소", EN: "Cancel", CH: "取消" },
    sampleLinkNoneYet: { KR: "없음", EN: "None", CH: "无" },
    orderCancelled: { KR: "취소", EN: "Cancelled", CH: "已取消" },
    orderNotFound: { KR: "구매오더수신 DB 에 아직 없는 오더입니다.", EN: "This order is not in the purchase-order database yet.", CH: "采购订单库中尚无该订单。" },
    orderDate: { KR: "발주일(SAP)", EN: "Order date (SAP)", CH: "下单日（SAP）" },
    orderVendor: { KR: "공급업체", EN: "Vendor", CH: "供货公司" },
    orderAmount: { KR: "금액", EN: "Amount", CH: "金额" },
    orderOwner: { KR: "담당자", EN: "In charge", CH: "担当" },
    orderItems: { KR: "품목 {n}줄", EN: "{n} items", CH: "{n} 项物料" },
    orderItemName: { KR: "품명", EN: "Description", CH: "品名" },
    orderQty: { KR: "수량", EN: "Qty", CH: "数量" },
    orderUnitPrice: { KR: "단가", EN: "Unit price", CH: "单价" },
    orderDue: { KR: "요청납기", EN: "Requested", CH: "要求交期" },
    orderFiles: { KR: "첨부파일 {n}개", EN: "{n} attachments", CH: "{n} 个附件" },
    orderNoFiles: { KR: "첨부파일이 없습니다.", EN: "No attachments.", CH: "无附件。" },
    totalCount: { KR: "전체 {count}건", EN: "Total {count}", CH: "共 {count} 件" },
    refresh: { KR: "새로고침", EN: "Refresh", CH: "刷新" },
    tabAll: { KR: "전체", EN: "All", CH: "全部" },
    tabApproval: { KR: "승인 대기", EN: "Pending Approval", CH: "待审批" },
    loading: { KR: "데이터를 불러오는 중...", EN: "Loading...", CH: "加载中..." },
    empty: { KR: "등록된 PO가 없습니다.", EN: "No PO registered.", CH: "没有注册的PO。" },
    colPoNumber: { KR: "PO번호", EN: "PO No.", CH: "PO编号" },
    colDate: { KR: "날짜", EN: "Date", CH: "日期" },
    colSupplier: { KR: "공급업체", EN: "Supplier", CH: "供应商" },
    colCompany: { KR: "발주회사명", EN: "Issuing Company", CH: "发行公司名称" },
    colTotalAmount: { KR: "총금액(¥)", EN: "Total(¥)", CH: "总金额(¥)" },
    colSampleCost: { KR: "샘플비(¥)", EN: "Sample cost(¥)", CH: "打样费用(¥)" },
    colStatus: { KR: "상태", EN: "Status", CH: "状态" },
    colSubmittedAt: { KR: "상신일", EN: "Submitted", CH: "提交日期" },
    colApprove1: { KR: "1차승인", EN: "1st Approval", CH: "初审" },
    colApprove2: { KR: "최종승인", EN: "Final Approval", CH: "终审" },
    colSubmittedBy: { KR: "상신자", EN: "Submitted By", CH: "提交人" },
    cancelBtn: { KR: "취소", EN: "Cancel", CH: "取消" },
    noApprovalPermission: { KR: "결재 권한이 없거나 대기 중인 결재가 없습니다.", EN: "No approval authority or no pending approvals.", CH: "没有审批权限或没有待处理的审批。" },
    noPendingApproval: { KR: "대기 중인 결재가 없습니다.", EN: "No pending approvals.", CH: "没有待处理的审批。" },
    backToList: { KR: "목록으로", EN: "Back to List", CH: "返回列表" },
    submitApproval: { KR: "결재상신", EN: "Submit for Approval", CH: "提交审批" },
    approve1: { KR: "1차 결재 (核查)", EN: "1st Approval (核查)", CH: "初审 (核查)" },
    approve2: { KR: "최종 결재 (审批)", EN: "Final Approval (审批)", CH: "终审 (审批)" },
    downloadPdf: { KR: "PDF 다운로드", EN: "Download PDF", CH: "下载PDF" },
    cancelApproval: { KR: "결재취소", EN: "Cancel Approval", CH: "取消审批" },
    withdrawApproval: { KR: "상신취소", EN: "Withdraw Submission", CH: "撤回提交" },
    deleteBtn: { KR: "삭제", EN: "Delete", CH: "删除" },
    date: { KR: "날짜", EN: "Date", CH: "日期" },
    supplier: { KR: "공급업체", EN: "Supplier", CH: "供应商" },
    contactPerson: { KR: "담당자", EN: "Contact Person", CH: "联系人" },
    contactPhone: { KR: "연락처", EN: "Phone", CH: "电话" },
    email: { KR: "이메일", EN: "Email", CH: "邮箱" },
    totalAmountYuan: { KR: "총금액(¥)", EN: "Total(¥)", CH: "总金额(¥)" },
    pdfLoading: { KR: "PDF 로딩 중...", EN: "Loading PDF...", CH: "PDF加载中..." },
    statusDraft: { KR: "초안", EN: "Draft", CH: "草稿" },
    statusPending: { KR: "결재중 (1차)", EN: "Pending (1st)", CH: "审批中 (初审)" },
    statusApproved1: { KR: "결재중 (2차)", EN: "Pending (Final)", CH: "审批中 (终审)" },
    statusApproved2: { KR: "최종승인", EN: "Approved", CH: "已批准" },
    statusCancelled: { KR: "취소됨", EN: "Cancelled", CH: "已取消" },
    confirmSubmit: { KR: "결재를 상신하시겠습니까?", EN: "Submit for approval?", CH: "确认提交审批？" },
    confirmApprove1: { KR: "1차 결재를 진행하시겠습니까?", EN: "Proceed with 1st approval?", CH: "确认进行初审？" },
    confirmApprove2: { KR: "최종 결재를 진행하시겠습니까?", EN: "Proceed with final approval?", CH: "确认进行终审？" },
    confirmCancelApproval: { KR: "결재상신을 취소하시겠습니까? 초안 상태로 되돌아갑니다.", EN: "Cancel approval submission? It will revert to draft.", CH: "确认取消审批提交？将恢复为草稿状态。" },
    confirmWithdraw: { KR: "해당 발주서를 삭제하시겠습니까? 복구할 수 없습니다.", EN: "Delete this PO? This action cannot be undone.", CH: "确认删除该采购单？此操作不可恢复。" },
    errorWithdraw: { KR: "상신취소에 실패했습니다.", EN: "Failed to withdraw submission.", CH: "撤回提交失败。" },
    confirmCancelFromList: { KR: '"{poNumber}" 결재상신을 취소하시겠습니까?', EN: 'Cancel approval for "{poNumber}"?', CH: '确认取消"{poNumber}"的审批提交？' },
    confirmDelete: { KR: 'PO "{poNumber}"을(를) 삭제하시겠습니까?', EN: 'Delete PO "{poNumber}"?', CH: '确认删除PO "{poNumber}"？' },
    errorFetchList: { KR: "PO 목록을 불러오지 못했습니다.", EN: "Failed to load PO list.", CH: "无法加载PO列表。" },
    errorFetchDetail: { KR: "PO 상세 정보를 불러오지 못했습니다.", EN: "Failed to load PO details.", CH: "无法加载PO详情。" },
    errorSubmit: { KR: "결재 상신에 실패했습니다.", EN: "Failed to submit for approval.", CH: "提交审批失败。" },
    errorApprove: { KR: "결재에 실패했습니다.", EN: "Failed to approve.", CH: "审批失败。" },
    errorDelete: { KR: "PO 삭제에 실패했습니다.", EN: "Failed to delete PO.", CH: "删除PO失败。" },
    errorNoPdf: { KR: "다운로드할 PDF가 없습니다.", EN: "No PDF available to download.", CH: "没有可下载的PDF。" },
    errorCancelApproval: { KR: "결재취소 실패", EN: "Cancel approval failed", CH: "取消审批失败" },
    statusRejected: { KR: "승인거부", EN: "Rejected", CH: "已拒绝" },
    rejectApproval: { KR: "승인거부", EN: "Reject", CH: "拒绝" },
    errorReject: { KR: "승인거부에 실패했습니다.", EN: "Failed to reject.", CH: "拒绝失败。" },
    rejectModalTitle: { KR: "승인거부 사유", EN: "Rejection Reason", CH: "拒绝原因" },
    rejectReasonPlaceholder: { KR: "거부 사유를 입력하세요 (선택사항)", EN: "Enter rejection reason (optional)", CH: "输入拒绝原因（可选）" },
    rejectConfirmBtn: { KR: "거부 확인", EN: "Confirm Reject", CH: "确认拒绝" },
    colRejectedReason: { KR: "거부사유", EN: "Reject Reason", CH: "拒绝原因" },
    editPoTitle: { KR: "발주서 수정", EN: "Edit PO", CH: "修改采购单" },
    editPoSave: { KR: "저장 후 결재상신", EN: "Save & Submit", CH: "保存并提交" },
    editPoSaveOnly: { KR: "저장만", EN: "Save Only", CH: "仅保存" },
    errorEditPo: { KR: "발주서 수정에 실패했습니다.", EN: "Failed to update PO.", CH: "修改采购单失败。" },
    poPaymentCondition: { KR: "결제 조건 (합계 = 100%)", EN: "Payment Terms (Total = 100%)", CH: "付款条件 (合计 = 100%)" },
    poRateSumWarning: { KR: "합계: {sum}% (100%가 되어야 합니다)", EN: "Total: {sum}% (must be 100%)", CH: "合计: {sum}% (必须为100%)" },
    poRateSumOk: { KR: "합계: 100%", EN: "Total: 100%", CH: "合计: 100%" },
    rejectedBy: { KR: "거부자", EN: "Rejected By", CH: "拒绝人" },
    rejectedAt: { KR: "거부일", EN: "Rejected At", CH: "拒绝日期" },
    rejectedReason: { KR: "거부사유", EN: "Rejection Reason", CH: "拒绝原因" },
    searchPlaceholder: { KR: "PO번호, 공급업체 검색...", EN: "Search PO No., Supplier...", CH: "搜索PO编号、供应商..." },
    resetDate: { KR: "날짜 초기화", EN: "Reset date", CH: "重置日期" },
    allStatus: { KR: "전체 상태", EN: "All Status", CH: "全部状态" },
    allCompanies: { KR: "전체 발주회사", EN: "All Companies", CH: "全部发行公司" },
    allSuppliers: { KR: "전체 공급업체", EN: "All Suppliers", CH: "全部供应商" },
    selectedCount: { KR: "{count}개 선택", EN: "{count} selected", CH: "已选 {count} 个" },
    selectAll: { KR: "전체", EN: "All", CH: "全部" },
    clearAll: { KR: "해제", EN: "Clear", CH: "清除" },
    filterSearchPlaceholder: { KR: "검색...", EN: "Search...", CH: "搜索..." },
    download: { KR: "발주서 다운로드", EN: "Download POs", CH: "下载采购单" },
    downloadProgress: { KR: "{done}/{total} 내려받는 중...", EN: "{done}/{total} downloading...", CH: "{done}/{total} 下载中..." },
    downloadNoPdf: { KR: "PDF 가 없는 건은 건너뜁니다: {list}", EN: "Skipped (no PDF): {list}", CH: "已跳过(无PDF): {list}" },
    downloadNone: { KR: "내려받을 PDF 가 없습니다.", EN: "No PDF to download.", CH: "没有可下载的PDF。" },
    downloadSelected: { KR: "{count}건 다운로드", EN: "Download {count}", CH: "下载 {count} 项" },
    downloadPickRows: { KR: "다운로드할 항목을 선택하세요", EN: "Select rows to download", CH: "请选择要下载的项目" },
    deleteBtn: { KR: "선택 삭제", EN: "Delete selected", CH: "删除所选" },
    deleteSelected: { KR: "선택 {count}건 삭제", EN: "Delete {count} selected", CH: "删除所选 {count} 件" },
    deletePickRows: { KR: "삭제할 발주서를 선택하세요", EN: "Select POs to delete", CH: "请选择要删除的采购订单" },
    deleteConfirm: { KR: "발주서 {count}건을 삭제합니다(최종승인 {approved}건 포함).\n삭제 표시만 하므로 '삭제된 발주서'에서 언제든 복구할 수 있습니다. 납기 모니터링에서는 빠지지만 입력값은 남아 있습니다. 계속할까요?", EN: "Delete {count} POs ({approved} final-approved).\nThey are only marked as deleted and can be restored any time from 'Deleted POs'. They leave delivery monitoring, but entered values are kept. Continue?", CH: "将删除 {count} 份采购订单（含终审 {approved} 份）。\n仅标记为已删除，可随时在“已删除采购订单”中恢复。将从交期监控中移除，但已录入的数据会保留。是否继续？" },
    deleteDone: { KR: "{count}건 삭제했습니다.", EN: "Deleted {count}.", CH: "已删除 {count} 件。" },
    deletedShow: { KR: "삭제된 발주서", EN: "Deleted POs", CH: "已删除采购订单" },
    deletedHide: { KR: "목록으로", EN: "Back to list", CH: "返回列表" },
    statusDeleted: { KR: "삭제됨", EN: "Deleted", CH: "已删除" },
    restoreBtn: { KR: "선택 복구", EN: "Restore selected", CH: "恢复所选" },
    restoreSelected: { KR: "선택 {count}건 복구", EN: "Restore {count} selected", CH: "恢复所选 {count} 件" },
    restorePickRows: { KR: "복구할 발주서를 선택하세요", EN: "Select POs to restore", CH: "请选择要恢复的采购订单" },
    restoreConfirm: { KR: "발주서 {count}건을 삭제 전 상태로 복구합니다. 계속할까요?", EN: "Restore {count} POs to their previous status?", CH: "将 {count} 份采购订单恢复到删除前的状态，是否继续？" },
    restoreDone: { KR: "{count}건 복구했습니다.", EN: "Restored {count}.", CH: "已恢复 {count} 件。" },
    downloading: { KR: "다운로드 중...", EN: "Downloading...", CH: "下载中..." },
    cancelBtn: { KR: "취소", EN: "Cancel", CH: "取消" },
    noSearchResults: { KR: "검색 결과가 없습니다.", EN: "No search results.", CH: "没有搜索结果。" },
    colCode: { KR: "코드", EN: "Code", CH: "代码" },
    rateExamplePlaceholder: { KR: "예: 1.50", EN: "e.g. 1.50", CH: "例: 1.50" },
    optionalPlaceholder: { KR: "(선택사항)", EN: "(optional)", CH: "(可选)" },
    closeBtn: { KR: "닫기", EN: "Close", CH: "关闭" },
    querying: { KR: "조회 중...", EN: "Loading...", CH: "查询中..." },
    supplierDetailTitle: { KR: "공급업체 상세정보", EN: "Supplier Details", CH: "供应商详情" },
    supplierNameCn: { KR: "중국명", EN: "Chinese Name", CH: "中文名称" },
    supplierNameKr: { KR: "한국명", EN: "Korean Name", CH: "韩文名称" },
    supplierNameBr: { KR: "브랜드명", EN: "Brand Name", CH: "品牌名称" },
    legalRepresentative: { KR: "법인대표", EN: "Legal Representative", CH: "法人代表" },
    categoryMain: { KR: "분류 (대)", EN: "Category (Main)", CH: "分类 (大)" },
    categorySub: { KR: "분류 (소)", EN: "Category (Sub)", CH: "分类 (小)" },
    address: { KR: "주소", EN: "Address", CH: "地址" },
    registeredCapital: { KR: "등록자본금", EN: "Registered Capital", CH: "注册资本" },
    establishedDate: { KR: "설립일", EN: "Established Date", CH: "成立日期" },
    employeeCount: { KR: "직원수", EN: "Employee Count", CH: "员工人数" },
    remarks: { KR: "비고", EN: "Remarks", CH: "备注" },
    handledProducts: { KR: "취급 제품", EN: "Handled Products", CH: "经营产品" },
    noProductsRegistered: { KR: "등록된 제품이 없습니다.", EN: "No products registered.", CH: "没有注册的产品。" },
    colHqCode: { KR: "본사코드", EN: "HQ Code", CH: "总部代码" },
    colHqProductName: { KR: "본사제품명", EN: "HQ Product Name", CH: "总部产品名称" },
    colChinaProductName: { KR: "중국제품명", EN: "China Product Name", CH: "中国产品名称" },
    colVatIncludedYuan: { KR: "증치세포함가 (¥)", EN: "VAT Included Price (¥)", CH: "含增值税价格 (¥)" },
    codeDetailTitle: { KR: "코드 상세정보", EN: "Code Details", CH: "代码详情" },
    noImage: { KR: "이미지 없음", EN: "No image", CH: "无图片" },
    category: { KR: "분류", EN: "Category", CH: "分类" },
    chinaCode: { KR: "중국코드", EN: "China Code", CH: "中国代码" },
    spec: { KR: "Spec", EN: "Spec", CH: "规格" },
    exportUnitPrice: { KR: "수출단가", EN: "Export Unit Price", CH: "出口单价" },
    exportUnitPriceYuan: { KR: "수출단가 (위안)", EN: "Export Unit Price (RMB)", CH: "出口单价 (人民币)" },
    supplyPriceLabel: { KR: "공급가", EN: "Supply Price", CH: "供应价格" },
    vatIncludedPriceLabel: { KR: "증치세포함가", EN: "VAT Included Price", CH: "含增值税价格" },
    supplierNotFound: { KR: "공급처 정보를 찾을 수 없습니다.", EN: "Supplier information not found.", CH: "未找到供应商信息。" },
    supplierLoadFailed: { KR: "공급처 정보를 불러올 수 없습니다.", EN: "Failed to load supplier information.", CH: "无法加载供应商信息。" },
    codeLoadFailed: { KR: "코드 정보를 불러올 수 없습니다.", EN: "Failed to load code information.", CH: "无法加载代码信息。" }
  },
  holiday: {
    pageTitle: { KR: "중국 공휴일", EN: "China Holidays", CH: "中国节假日" },
    pageDesc: {
      KR: "국무원 공고를 받아 둡니다. 춘절 실제 휴무처럼 공고에 없는 날은 직접 더하세요.",
      EN: "Fetched from the State Council notice. Add days it does not cover, such as the actual Spring Festival shutdown.",
      CH: "来自国务院公告。公告未包含的日期（如春节实际停工）请手动添加。",
    },
    year: { KR: "연도", EN: "Year", CH: "年份" },
    update: { KR: "공휴일 업데이트", EN: "Update Holidays", CH: "更新节假日" },
    updating: { KR: "받아오는 중...", EN: "Fetching...", CH: "获取中..." },
    add: { KR: "추가", EN: "Add", CH: "添加" },
    edit: { KR: "수정", EN: "Edit", CH: "编辑" },
    del: { KR: "삭제", EN: "Delete", CH: "删除" },
    save: { KR: "저장", EN: "Save", CH: "保存" },
    cancel: { KR: "취소", EN: "Cancel", CH: "取消" },
    close: { KR: "닫기", EN: "Close", CH: "关闭" },
    colDate: { KR: "날짜", EN: "Date", CH: "日期" },
    colWeekday: { KR: "요일", EN: "Day", CH: "星期" },
    colNameZh: { KR: "이름(중문)", EN: "Name (CN)", CH: "名称（中文）" },
    colNameKo: { KR: "이름(국문)", EN: "Name (KR)", CH: "名称（韩文）" },
    colNameEn: { KR: "이름(영문)", EN: "Name (EN)", CH: "名称（英文）" },
    colType: { KR: "구분", EN: "Type", CH: "类型" },
    colSource: { KR: "출처", EN: "Source", CH: "来源" },
    colNote: { KR: "비고", EN: "Note", CH: "备注" },
    typeOff: { KR: "휴일", EN: "Day off", CH: "休假" },
    typeWork: { KR: "대체근무", EN: "Make-up workday", CH: "调休上班" },
    typeWorkHint: {
      KR: "연휴를 붙이려고 주말을 근무일로 돌린 날입니다.",
      EN: "A weekend turned into a workday to extend the holiday.",
      CH: "为连休而将周末调整为上班日。",
    },
    sourceAuto: { KR: "공고", EN: "Notice", CH: "公告" },
    sourceManual: { KR: "직접입력", EN: "Manual", CH: "手动" },
    summary: { KR: "휴일 {off}일 · 대체근무 {work}일", EN: "{off} days off · {work} make-up workdays", CH: "休假 {off} 天 · 调休 {work} 天" },
    loading: { KR: "불러오는 중...", EN: "Loading...", CH: "加载中..." },
    empty: { KR: "등록된 공휴일이 없습니다. '공휴일 업데이트'를 눌러 주세요.", EN: "No holidays yet. Click 'Update Holidays'.", CH: "暂无节假日。请点击“更新节假日”。" },
    modalAdd: { KR: "공휴일 추가", EN: "Add Holiday", CH: "添加节假日" },
    modalEdit: { KR: "공휴일 수정", EN: "Edit Holiday", CH: "编辑节假日" },
    deleteConfirm: { KR: "{date} {name} 을(를) 지우시겠습니까?", EN: "Delete {date} {name}?", CH: "确定删除 {date} {name} 吗？" },
    dateRequired: { KR: "날짜를 입력하세요.", EN: "Enter a date.", CH: "请输入日期。" },
    nameRequired: { KR: "이름을 입력하세요.", EN: "Enter a name.", CH: "请输入名称。" },
    updated: { KR: "{year}년 — 새로 {added}일, 고침 {updated}일, 직접입력 지킴 {kept}일 (모두 {total}일)", EN: "{year} — {added} added, {updated} updated, {kept} manual kept ({total} total)", CH: "{year}年 — 新增 {added} 天，更新 {updated} 天，保留手动 {kept} 天（共 {total} 天）" },
    updateFailed: { KR: "받아오지 못했습니다: {msg}", EN: "Could not fetch: {msg}", CH: "获取失败：{msg}" },
    saveFailed: { KR: "저장하지 못했습니다: {msg}", EN: "Could not save: {msg}", CH: "保存失败：{msg}" },
    viewCalendar: { KR: "달력", EN: "Calendar", CH: "日历" },
    viewList: { KR: "목록", EN: "List", CH: "列表" },
    legendOff: { KR: "휴일", EN: "Day off", CH: "休假" },
    legendWork: { KR: "대체근무", EN: "Make-up workday", CH: "调休上班" },
    legendManual: { KR: "직접입력", EN: "Manual", CH: "手动" },
    clickToAdd: { KR: "날짜를 누르면 추가·수정할 수 있습니다.", EN: "Click a date to add or edit.", CH: "点击日期可添加或编辑。" },
    monthLabel: { KR: "{m}월", EN: "{m}", CH: "{m}月" },
    notYet: {
      KR: "다음 해 일정은 보통 전년 11~12월에 발표됩니다.",
      EN: "Next year's schedule is usually announced in Nov-Dec of the previous year.",
      CH: "次年安排通常在上一年11—12月公布。",
    },
  },

  sampleControl: {
    pageDesc: {
      KR: "중국에서 뜬 용기 샘플을 한 줄씩 남깁니다. 줄을 누르면 고치고, 사진을 누르면 원본 크기로 봅니다. 쓰던 엑셀(打样记录)을 그대로 올리면 셀에 박힌 사진까지 함께 들어옵니다.",
      EN: "One row per container sample made in China. Click a row to edit, click a photo to view it full size. Uploading the original 打样记录 workbook also brings in the photos embedded in its cells.",
      CH: "逐行记录在中国制作的容器打样。点击行可编辑，点击照片可查看原图。直接上传原有的《打样记录》表格时，单元格内的照片也会一并导入。",
    },
    search: { KR: "제품·공급상 검색", EN: "Search product or supplier", CH: "搜索产品或供应商" },
    allProgress: { KR: "진행 전체", EN: "All progress", CH: "全部进度" },
    clear: { KR: "조건 지우기", EN: "Clear", CH: "清除条件" },
    count: { KR: "{n}건", EN: "{n} rows", CH: "{n} 条" },
    add: { KR: "등록", EN: "Add", CH: "登记" },
    excel: { KR: "엑셀", EN: "Excel", CH: "Excel" },
    importExcel: { KR: "엑셀 업로드", EN: "Upload Excel", CH: "上传 Excel" },
    importing: { KR: "읽는 중...", EN: "Reading...", CH: "读取中..." },
    importDone: {
      KR: "{total}줄 중 {added}줄을 등록했습니다 (사진 {images}장). 이미 있는 것 {skipped}줄은 건너뛰었습니다.",
      EN: "Added {added} of {total} rows ({images} photos). Skipped {skipped} already present.",
      CH: "共 {total} 行，已登记 {added} 行（照片 {images} 张），跳过已存在的 {skipped} 行。",
    },
    loading: { KR: "불러오는 중...", EN: "Loading...", CH: "加载中..." },
    empty: { KR: "등록된 샘플이 없습니다.", EN: "No samples registered.", CH: "暂无打样记录。" },
    emptyFiltered: { KR: "조건에 맞는 줄이 없습니다.", EN: "No rows match the filter.", CH: "没有符合条件的行。" },

    colImage: { KR: "사진", EN: "Photo", CH: "图片" },
    colProduct: { KR: "제품", EN: "Product", CH: "产品" },
    colCapacity: { KR: "용량", EN: "Capacity", CH: "容量" },
    colDept: { KR: "부서", EN: "Department", CH: "部门" },
    colPerson: { KR: "담당자", EN: "In charge", CH: "担当" },
    colRequirement: { KR: "요구사항", EN: "Requirement", CH: "要求" },
    colSupplier: { KR: "공급상", EN: "Supplier", CH: "供应商" },
    colStart: { KR: "시작일", EN: "Start", CH: "开始时间" },
    colEnd: { KR: "완료일", EN: "Completed", CH: "完成时间" },
    colProgress: { KR: "진행", EN: "Progress", CH: "打样进度" },
    colIssues: { KR: "문제점", EN: "Issues", CH: "打样问题点" },
    colCost: { KR: "비용(¥)", EN: "Cost (¥)", CH: "打样费用(¥)" },
    colDeductible: { KR: "공제", EN: "Deductible", CH: "是否抵扣" },
    colNote: { KR: "비용처리", EN: "Settlement", CH: "费用处理" },
    colNo: { KR: "번호", EN: "No.", CH: "编号" },
    colPo: { KR: "발주서", EN: "PO", CH: "采购订单" },
    poTitle: { KR: "샘플비를 차감한 발주서", EN: "PO with sample cost deducted", CH: "抵扣打样费用的采购订单" },
    poOpen: { KR: "발주서 보기", EN: "View PO", CH: "查看采购订单" },
    poNotFound: { KR: "발주서를 찾지 못했습니다.", EN: "PO not found.", CH: "未找到采购订单。" },
    poTotal: { KR: "합계", EN: "Total", CH: "合计" },
    poStatus_draft: { KR: "초안", EN: "Draft", CH: "草稿" },
    poStatus_pending: { KR: "결재 대기", EN: "Pending", CH: "待审批" },
    poStatus_approved1: { KR: "1차 승인", EN: "1st approved", CH: "一审通过" },
    poStatus_approved2: { KR: "최종 승인", EN: "Final approved", CH: "终审通过" },

    /* 产品 — 실제 기록에 쓰이던 용기 종류. 저장값은 중국어 그대로다 */
    p软管: { KR: "튜브", EN: "Tube", CH: "软管" },
    p玻璃滴管瓶: { KR: "유리 드로퍼병", EN: "Glass dropper bottle", CH: "玻璃滴管瓶" },
    p水乳瓶: { KR: "스킨·로션병", EN: "Toner/lotion bottle", CH: "水乳瓶" },
    p真空瓶: { KR: "에어리스병", EN: "Airless bottle", CH: "真空瓶" },
    p膏霜罐: { KR: "크림 용기", EN: "Cream jar", CH: "膏霜罐" },
    p滴管瓶: { KR: "드로퍼병", EN: "Dropper bottle", CH: "滴管瓶" },
    p乳液瓶: { KR: "로션병", EN: "Lotion bottle", CH: "乳液瓶" },
    p喷雾瓶: { KR: "스프레이병", EN: "Spray bottle", CH: "喷雾瓶" },
    p研磨容器: { KR: "마사지(롤러) 용기", EN: "Massage applicator", CH: "研磨容器" },
    p头部护理容器: { KR: "두피케어 용기", EN: "Scalp care container", CH: "头部护理容器" },
    p罐子: { KR: "단지(자)", EN: "Jar", CH: "罐子" },
    p双仓西林瓶: { KR: "이중 바이알", EN: "Dual-chamber vial", CH: "双仓西林瓶" },
    p防晒瓶: { KR: "선크림 용기", EN: "Sunscreen bottle", CH: "防晒瓶" },
    p真空乳液瓶: { KR: "에어리스 로션병", EN: "Airless lotion bottle", CH: "真空乳液瓶" },
    p香体膏容器: { KR: "데오드란트 용기", EN: "Deodorant stick", CH: "香体膏容器" },
    pPETG滴管瓶: { KR: "PETG 드로퍼병", EN: "PETG dropper bottle", CH: "PETG滴管瓶" },
    p玻璃罐子: { KR: "유리 단지", EN: "Glass jar", CH: "玻璃罐子" },
    p尖嘴瓶: { KR: "노즐병", EN: "Nozzle bottle", CH: "尖嘴瓶" },
    p超声刀包材: { KR: "초음파기기 포장재", EN: "Ultrasound device packaging", CH: "超声刀包材" },
    productOther: { KR: "직접 입력", EN: "Enter directly", CH: "直接输入" },

    /* 打样进度 — 엑셀에 적히던 값 그대로 담고, 보여줄 때만 말을 바꾼다 */
    progressOk: { KR: "OK", EN: "OK", CH: "OK" },
    progressNg: { KR: "NG", EN: "NG", CH: "NG" },
    progressChecking: { KR: "확인중", EN: "Checking", CH: "确认中" },
    progressSampling: { KR: "샘플 제작중", EN: "Sampling", CH: "打样中" },
    progressResample: { KR: "재샘플", EN: "Re-sampling", CH: "二次打样" },
    progressCancelled: { KR: "취소", EN: "Cancelled", CH: "取消" },
    progressPaused: { KR: "보류", EN: "On hold", CH: "暂停" },
    /* 备注 — 정산 상태를 적는 칸이다 */
    noteUnsettled: { KR: "미정산", EN: "Unsettled", CH: "未结算" },
    noteLinked: { KR: "발주서연결완료", EN: "Linked to PO", CH: "已关联订单" },
    noteDeducted: { KR: "공제완료", EN: "Deducted", CH: "已抵扣" },
    noteInvoiced: { KR: "계산서 발행", EN: "Invoiced", CH: "已开票" },
    /* 打样费用 은 위안화다 */
    currencySymbol: { KR: "¥", EN: "¥", CH: "¥" },
    costUnit: { KR: "위안", EN: "CNY", CH: "元" },
    yes: { KR: "예", EN: "Yes", CH: "是" },
    no: { KR: "아니오", EN: "No", CH: "否" },

    supplierSearch: { KR: "업체 이름을 치면 찾습니다", EN: "Type a company name to search", CH: "输入公司名称进行搜索" },
    supplierNoHit: { KR: "거래처 표에 없습니다 — 적은 대로 저장됩니다", EN: "Not in the supplier database - saved as typed", CH: "供应商库中没有，将按输入内容保存" },
    supplierTitle: { KR: "공급상 정보", EN: "Supplier", CH: "供应商信息" },
    supplierNone: { KR: "거래처 표에 없는 공급상입니다.", EN: "Not found in the supplier database.", CH: "供应商库中没有该公司。" },
    sNameKr: { KR: "한글 이름", EN: "Korean name", CH: "韩文名称" },
    sRep: { KR: "대표자", EN: "Representative", CH: "法定代表人" },
    sCapital: { KR: "자본금", EN: "Registered capital", CH: "注册资本" },
    sAddress: { KR: "주소", EN: "Address", CH: "地址" },
    sEstablished: { KR: "설립일", EN: "Established", CH: "成立日期" },
    sEmployees: { KR: "직원 수", EN: "Employees", CH: "员工人数" },
    sCategory: { KR: "분류", EN: "Category", CH: "分类" },
    sContact: { KR: "담당자", EN: "Contact", CH: "联系人" },
    sPhone: { KR: "연락처", EN: "Phone", CH: "电话" },
    sEmail: { KR: "메일", EN: "Email", CH: "邮箱" },
    sWebsite: { KR: "홈페이지", EN: "Website", CH: "网站" },
    sRemarks: { KR: "비고", EN: "Remarks", CH: "备注" },
    deleteMode: { KR: "삭제", EN: "Delete", CH: "删除" },
    deleteSelected: { KR: "{n}건 삭제", EN: "Delete {n}", CH: "删除 {n} 条" },
    deleteCancel: { KR: "선택 취소", EN: "Cancel", CH: "取消选择" },
    deleteNone: { KR: "지울 줄을 고르세요.", EN: "Select rows to delete.", CH: "请选择要删除的行。" },
    deleteSelectedConfirm: { KR: "고른 {n}건을 지울까요? 사진도 함께 지워집니다.", EN: "Delete the {n} selected rows? Their photos are removed too.", CH: "确定删除所选 {n} 条吗？照片也会一并删除。" },
    importRenamed: { KR: " 담당자 {n}명은 등록된 사용자 이름으로 맞췄습니다.", EN: " Matched {n} people to registered users.", CH: " 已将 {n} 位担当匹配为系统用户。" },
    cfSearch: { KR: "값 찾기", EN: "Search values", CH: "查找值" },
    cfAll: { KR: "전체선택", EN: "Select all", CH: "全选" },
    cfNone: { KR: "모두해제", EN: "Clear", CH: "全不选" },
    cfEmpty: { KR: "(빈 값)", EN: "(blank)", CH: "（空白）" },
    deptAuto: { KR: "담당자를 고르면 채워집니다", EN: "Filled in when you pick a person", CH: "选择担当后自动填入" },
    personSearch: { KR: "이름을 치면 찾습니다", EN: "Type a name to search", CH: "输入姓名进行搜索" },
    personNone: { KR: "찾는 사람이 없습니다", EN: "No matching user", CH: "未找到相关人员" },
    personKeep: { KR: "적은 대로 쓰기", EN: "Use as typed", CH: "按输入内容使用" },
    addTitle: { KR: "샘플 등록", EN: "Add a sample", CH: "登记打样" },
    editTitle: { KR: "샘플 수정", EN: "Edit sample", CH: "编辑打样" },
    needProduct: { KR: "제품을 입력하세요.", EN: "Enter the product.", CH: "请输入产品。" },
    save: { KR: "저장", EN: "Save", CH: "保存" },
    saved: { KR: "저장했습니다.", EN: "Saved.", CH: "已保存。" },
    close: { KR: "닫기", EN: "Close", CH: "关闭" },
    delete: { KR: "삭제", EN: "Delete", CH: "删除" },
    deleteConfirm: { KR: "{name} 줄을 지울까요? 사진도 함께 지워집니다.", EN: "Delete {name}? Its photo is removed too.", CH: "确定删除 {name} 吗？照片也会一并删除。" },
    deleted: { KR: "지웠습니다.", EN: "Deleted.", CH: "已删除。" },

    photoZoom: { KR: "누르면 원본 크기로 봅니다", EN: "Click to view full size", CH: "点击查看原图" },
    noPhoto: { KR: "사진 없음", EN: "No photo", CH: "无照片" },
    choosePhoto: { KR: "사진 올리기", EN: "Upload photos", CH: "上传照片" },
    photoCount: { KR: "사진 {n}장", EN: "{n} photos", CH: "{n} 张照片" },
    photoMore: { KR: "+{n}", EN: "+{n}", CH: "+{n}" },
    photoHint: { KR: "여러 장을 한 번에 고를 수 있습니다.", EN: "You can select several files at once.", CH: "可一次选择多张照片。" },
    removeThisPhoto: { KR: "이 사진 지우기", EN: "Remove this photo", CH: "删除这张照片" },
    removePhoto: { KR: "사진 지우기", EN: "Remove photo", CH: "删除照片" },
    imageAfterSave: {
      KR: "먼저 저장하면 사진을 올릴 수 있습니다.",
      EN: "Save first, then you can upload a photo.",
      CH: "请先保存，之后即可上传照片。",
    },
  },

  deliveryMonitoring: {
    pageDesc: {
      KR: "최종승인된 발주서의 품목별로 발주 → 생산 → 선적 → 입고를 한 줄에서 봅니다. 예정일은 주말은 세고 중국 공휴일은 빼고 계산합니다.",
      EN: "One row per item of fully approved POs: order to production to shipping to receipt. Due dates count weekends but skip Chinese holidays.",
      CH: "按最终审批采购订单的物料逐行显示：下单、生产、装运、入库。预计日期计入周末，但不计中国法定节假日。",
    },
    search: { KR: "구매오더·자재코드 검색", EN: "Search PO or material code", CH: "搜索采购订单或物料编码" },
    dateField: { KR: "기준", EN: "Date basis", CH: "基准" },
    viewAll: { KR: "전체 보기", EN: "Show all", CH: "显示全部" },
    viewActive: { KR: "취소 제외", EN: "Hide cancelled", CH: "不含已取消" },
    hideReceived: { KR: "입고완료 제외", EN: "Hide received", CH: "不含已入库" },
    viewCancelled: { KR: "취소된 것만", EN: "Cancelled only", CH: "仅已取消" },
    viewHint: { KR: "제목을 눌러 취소된 건을 함께 볼 수 있습니다.", EN: "Click the header to include cancelled orders.", CH: "点击标题可一并查看已取消的订单。" },
    colStatus: { KR: "상태", EN: "Status", CH: "状态" },
    colSubmittedAt: { KR: "상신일", EN: "Submitted", CH: "提交日期" },
    colApprove1: { KR: "1차승인", EN: "1st Approval", CH: "初审" },
    colApprove2: { KR: "최종승인", EN: "Final Approval", CH: "终审" },
    colSubmittedBy: { KR: "상신자", EN: "Submitted By", CH: "提交人" },
    cancelBtn: { KR: "취소", EN: "Cancel", CH: "取消" },
    noApprovalPermission: { KR: "결재 권한이 없거나 대기 중인 결재가 없습니다.", EN: "No approval authority or no pending approvals.", CH: "没有审批权限或没有待处理的审批。" },
    noPendingApproval: { KR: "대기 중인 결재가 없습니다.", EN: "No pending approvals.", CH: "没有待处理的审批。" },
    backToList: { KR: "목록으로", EN: "Back to List", CH: "返回列表" },
    submitApproval: { KR: "결재상신", EN: "Submit for Approval", CH: "提交审批" },
    approve1: { KR: "1차 결재 (核查)", EN: "1st Approval (核查)", CH: "初审 (核查)" },
    approve2: { KR: "최종 결재 (审批)", EN: "Final Approval (审批)", CH: "终审 (审批)" },
    downloadPdf: { KR: "PDF 다운로드", EN: "Download PDF", CH: "下载PDF" },
    cancelApproval: { KR: "결재취소", EN: "Cancel Approval", CH: "取消审批" },
    withdrawApproval: { KR: "상신취소", EN: "Withdraw Submission", CH: "撤回提交" },
    deleteBtn: { KR: "삭제", EN: "Delete", CH: "删除" },
    date: { KR: "날짜", EN: "Date", CH: "日期" },
    supplier: { KR: "공급업체", EN: "Supplier", CH: "供应商" },
    contactPerson: { KR: "담당자", EN: "Contact Person", CH: "联系人" },
    contactPhone: { KR: "연락처", EN: "Phone", CH: "电话" },
    email: { KR: "이메일", EN: "Email", CH: "邮箱" },
    totalAmountYuan: { KR: "총금액(¥)", EN: "Total(¥)", CH: "总金额(¥)" },
    pdfLoading: { KR: "PDF 로딩 중...", EN: "Loading PDF...", CH: "PDF加载中..." },
    statusDraft: { KR: "초안", EN: "Draft", CH: "草稿" },
    statusPending: { KR: "결재중 (1차)", EN: "Pending (1st)", CH: "审批中 (初审)" },
    statusApproved1: { KR: "결재중 (2차)", EN: "Pending (Final)", CH: "审批中 (终审)" },
    statusApproved2: { KR: "최종승인", EN: "Approved", CH: "已批准" },
    statusCancelled: { KR: "취소됨", EN: "Cancelled", CH: "已取消" },
    confirmSubmit: { KR: "결재를 상신하시겠습니까?", EN: "Submit for approval?", CH: "确认提交审批？" },
    confirmApprove1: { KR: "1차 결재를 진행하시겠습니까?", EN: "Proceed with 1st approval?", CH: "确认进行初审？" },
    confirmApprove2: { KR: "최종 결재를 진행하시겠습니까?", EN: "Proceed with final approval?", CH: "确认进行终审？" },
    confirmCancelApproval: { KR: "결재상신을 취소하시겠습니까? 초안 상태로 되돌아갑니다.", EN: "Cancel approval submission? It will revert to draft.", CH: "确认取消审批提交？将恢复为草稿状态。" },
    confirmWithdraw: { KR: "해당 발주서를 삭제하시겠습니까? 복구할 수 없습니다.", EN: "Delete this PO? This action cannot be undone.", CH: "确认删除该采购单？此操作不可恢复。" },
    errorWithdraw: { KR: "상신취소에 실패했습니다.", EN: "Failed to withdraw submission.", CH: "撤回提交失败。" },
    confirmCancelFromList: { KR: '"{poNumber}" 결재상신을 취소하시겠습니까?', EN: 'Cancel approval for "{poNumber}"?', CH: '确认取消"{poNumber}"的审批提交？' },
    confirmDelete: { KR: 'PO "{poNumber}"을(를) 삭제하시겠습니까?', EN: 'Delete PO "{poNumber}"?', CH: '确认删除PO "{poNumber}"？' },
    errorFetchList: { KR: "PO 목록을 불러오지 못했습니다.", EN: "Failed to load PO list.", CH: "无法加载PO列表。" },
    errorFetchDetail: { KR: "PO 상세 정보를 불러오지 못했습니다.", EN: "Failed to load PO details.", CH: "无法加载PO详情。" },
    errorSubmit: { KR: "결재 상신에 실패했습니다.", EN: "Failed to submit for approval.", CH: "提交审批失败。" },
    errorApprove: { KR: "결재에 실패했습니다.", EN: "Failed to approve.", CH: "审批失败。" },
    errorDelete: { KR: "PO 삭제에 실패했습니다.", EN: "Failed to delete PO.", CH: "删除PO失败。" },
    errorNoPdf: { KR: "다운로드할 PDF가 없습니다.", EN: "No PDF available to download.", CH: "没有可下载的PDF。" },
    errorCancelApproval: { KR: "결재취소 실패", EN: "Cancel approval failed", CH: "取消审批失败" },
    statusRejected: { KR: "승인거부", EN: "Rejected", CH: "已拒绝" },
    rejectApproval: { KR: "승인거부", EN: "Reject", CH: "拒绝" },
    errorReject: { KR: "승인거부에 실패했습니다.", EN: "Failed to reject.", CH: "拒绝失败。" },
    rejectModalTitle: { KR: "승인거부 사유", EN: "Rejection Reason", CH: "拒绝原因" },
    rejectReasonPlaceholder: { KR: "거부 사유를 입력하세요 (선택사항)", EN: "Enter rejection reason (optional)", CH: "输入拒绝原因（可选）" },
    rejectConfirmBtn: { KR: "거부 확인", EN: "Confirm Reject", CH: "确认拒绝" },
    colRejectedReason: { KR: "거부사유", EN: "Reject Reason", CH: "拒绝原因" },
    editPoTitle: { KR: "발주서 수정", EN: "Edit PO", CH: "修改采购单" },
    editPoSave: { KR: "저장 후 결재상신", EN: "Save & Submit", CH: "保存并提交" },
    editPoSaveOnly: { KR: "저장만", EN: "Save Only", CH: "仅保存" },
    errorEditPo: { KR: "발주서 수정에 실패했습니다.", EN: "Failed to update PO.", CH: "修改采购单失败。" },
    poPaymentCondition: { KR: "결제 조건 (합계 = 100%)", EN: "Payment Terms (Total = 100%)", CH: "付款条件 (合计 = 100%)" },
    poRateSumWarning: { KR: "합계: {sum}% (100%가 되어야 합니다)", EN: "Total: {sum}% (must be 100%)", CH: "合计: {sum}% (必须为100%)" },
    poRateSumOk: { KR: "합계: 100%", EN: "Total: 100%", CH: "合计: 100%" },
    rejectedBy: { KR: "거부자", EN: "Rejected By", CH: "拒绝人" },
    rejectedAt: { KR: "거부일", EN: "Rejected At", CH: "拒绝日期" },
    rejectedReason: { KR: "거부사유", EN: "Rejection Reason", CH: "拒绝原因" },
    searchPlaceholder: { KR: "PO번호, 공급업체 검색...", EN: "Search PO No., Supplier...", CH: "搜索PO编号、供应商..." },
    resetDate: { KR: "날짜 초기화", EN: "Reset date", CH: "重置日期" },
    allStatus: { KR: "전체 상태", EN: "All Status", CH: "全部状态" },
    allCompanies: { KR: "전체 발주회사", EN: "All Companies", CH: "全部发行公司" },
    allSuppliers: { KR: "전체 공급업체", EN: "All Suppliers", CH: "全部供应商" },
    selectedCount: { KR: "{count}개 선택", EN: "{count} selected", CH: "已选 {count} 个" },
    selectAll: { KR: "전체", EN: "All", CH: "全部" },
    clearAll: { KR: "해제", EN: "Clear", CH: "清除" },
    filterSearchPlaceholder: { KR: "검색...", EN: "Search...", CH: "搜索..." },
    download: { KR: "발주서 다운로드", EN: "Download POs", CH: "下载采购单" },
    downloadProgress: { KR: "{done}/{total} 내려받는 중...", EN: "{done}/{total} downloading...", CH: "{done}/{total} 下载中..." },
    downloadNoPdf: { KR: "PDF 가 없는 건은 건너뜁니다: {list}", EN: "Skipped (no PDF): {list}", CH: "已跳过(无PDF): {list}" },
    downloadNone: { KR: "내려받을 PDF 가 없습니다.", EN: "No PDF to download.", CH: "没有可下载的PDF。" },
    downloadSelected: { KR: "{count}건 다운로드", EN: "Download {count}", CH: "下载 {count} 项" },
    downloadPickRows: { KR: "다운로드할 항목을 선택하세요", EN: "Select rows to download", CH: "请选择要下载的项目" },
    downloading: { KR: "다운로드 중...", EN: "Downloading...", CH: "下载中..." },
    cancelBtn: { KR: "취소", EN: "Cancel", CH: "取消" },
    noSearchResults: { KR: "검색 결과가 없습니다.", EN: "No search results.", CH: "没有搜索结果。" },
    colCode: { KR: "코드", EN: "Code", CH: "代码" },
    rateExamplePlaceholder: { KR: "예: 1.50", EN: "e.g. 1.50", CH: "例: 1.50" },
    optionalPlaceholder: { KR: "(선택사항)", EN: "(optional)", CH: "(可选)" },
    closeBtn: { KR: "닫기", EN: "Close", CH: "关闭" },
    querying: { KR: "조회 중...", EN: "Loading...", CH: "查询中..." },
    supplierDetailTitle: { KR: "공급업체 상세정보", EN: "Supplier Details", CH: "供应商详情" },
    supplierNameCn: { KR: "중국명", EN: "Chinese Name", CH: "中文名称" },
    supplierNameKr: { KR: "한국명", EN: "Korean Name", CH: "韩文名称" },
    supplierNameBr: { KR: "브랜드명", EN: "Brand Name", CH: "品牌名称" },
    legalRepresentative: { KR: "법인대표", EN: "Legal Representative", CH: "法人代表" },
    categoryMain: { KR: "분류 (대)", EN: "Category (Main)", CH: "分类 (大)" },
    categorySub: { KR: "분류 (소)", EN: "Category (Sub)", CH: "分类 (小)" },
    address: { KR: "주소", EN: "Address", CH: "地址" },
    registeredCapital: { KR: "등록자본금", EN: "Registered Capital", CH: "注册资本" },
    establishedDate: { KR: "설립일", EN: "Established Date", CH: "成立日期" },
    employeeCount: { KR: "직원수", EN: "Employee Count", CH: "员工人数" },
    remarks: { KR: "비고", EN: "Remarks", CH: "备注" },
    handledProducts: { KR: "취급 제품", EN: "Handled Products", CH: "经营产品" },
    noProductsRegistered: { KR: "등록된 제품이 없습니다.", EN: "No products registered.", CH: "没有注册的产品。" },
    colHqCode: { KR: "본사코드", EN: "HQ Code", CH: "总部代码" },
    colHqProductName: { KR: "본사제품명", EN: "HQ Product Name", CH: "总部产品名称" },
    colChinaProductName: { KR: "중국제품명", EN: "China Product Name", CH: "中国产品名称" },
    colVatIncludedYuan: { KR: "증치세포함가 (¥)", EN: "VAT Included Price (¥)", CH: "含增值税价格 (¥)" },
    codeDetailTitle: { KR: "코드 상세정보", EN: "Code Details", CH: "代码详情" },
    noImage: { KR: "이미지 없음", EN: "No image", CH: "无图片" },
    category: { KR: "분류", EN: "Category", CH: "分类" },
    chinaCode: { KR: "중국코드", EN: "China Code", CH: "中国代码" },
    spec: { KR: "Spec", EN: "Spec", CH: "规格" },
    exportUnitPrice: { KR: "수출단가", EN: "Export Unit Price", CH: "出口单价" },
    exportUnitPriceYuan: { KR: "수출단가 (위안)", EN: "Export Unit Price (RMB)", CH: "出口单价 (人民币)" },
    supplyPriceLabel: { KR: "공급가", EN: "Supply Price", CH: "供应价格" },
    vatIncludedPriceLabel: { KR: "증치세포함가", EN: "VAT Included Price", CH: "含增值税价格" },
    supplierNotFound: { KR: "공급처 정보를 찾을 수 없습니다.", EN: "Supplier information not found.", CH: "未找到供应商信息。" },
    supplierLoadFailed: { KR: "공급처 정보를 불러올 수 없습니다.", EN: "Failed to load supplier information.", CH: "无法加载供应商信息。" },
    codeLoadFailed: { KR: "코드 정보를 불러올 수 없습니다.", EN: "Failed to load code information.", CH: "无法加载代码信息。" }
  },
  holiday: {
    pageTitle: { KR: "중국 공휴일", EN: "China Holidays", CH: "中国节假日" },
    pageDesc: {
      KR: "국무원 공고를 받아 둡니다. 춘절 실제 휴무처럼 공고에 없는 날은 직접 더하세요.",
      EN: "Fetched from the State Council notice. Add days it does not cover, such as the actual Spring Festival shutdown.",
      CH: "来自国务院公告。公告未包含的日期（如春节实际停工）请手动添加。",
    },
    year: { KR: "연도", EN: "Year", CH: "年份" },
    update: { KR: "공휴일 업데이트", EN: "Update Holidays", CH: "更新节假日" },
    updating: { KR: "받아오는 중...", EN: "Fetching...", CH: "获取中..." },
    add: { KR: "추가", EN: "Add", CH: "添加" },
    edit: { KR: "수정", EN: "Edit", CH: "编辑" },
    del: { KR: "삭제", EN: "Delete", CH: "删除" },
    save: { KR: "저장", EN: "Save", CH: "保存" },
    cancel: { KR: "취소", EN: "Cancel", CH: "取消" },
    close: { KR: "닫기", EN: "Close", CH: "关闭" },
    colDate: { KR: "날짜", EN: "Date", CH: "日期" },
    colWeekday: { KR: "요일", EN: "Day", CH: "星期" },
    colNameZh: { KR: "이름(중문)", EN: "Name (CN)", CH: "名称（中文）" },
    colNameKo: { KR: "이름(국문)", EN: "Name (KR)", CH: "名称（韩文）" },
    colNameEn: { KR: "이름(영문)", EN: "Name (EN)", CH: "名称（英文）" },
    colType: { KR: "구분", EN: "Type", CH: "类型" },
    colSource: { KR: "출처", EN: "Source", CH: "来源" },
    colNote: { KR: "비고", EN: "Note", CH: "备注" },
    typeOff: { KR: "휴일", EN: "Day off", CH: "休假" },
    typeWork: { KR: "대체근무", EN: "Make-up workday", CH: "调休上班" },
    typeWorkHint: {
      KR: "연휴를 붙이려고 주말을 근무일로 돌린 날입니다.",
      EN: "A weekend turned into a workday to extend the holiday.",
      CH: "为连休而将周末调整为上班日。",
    },
    sourceAuto: { KR: "공고", EN: "Notice", CH: "公告" },
    sourceManual: { KR: "직접입력", EN: "Manual", CH: "手动" },
    summary: { KR: "휴일 {off}일 · 대체근무 {work}일", EN: "{off} days off · {work} make-up workdays", CH: "休假 {off} 天 · 调休 {work} 天" },
    loading: { KR: "불러오는 중...", EN: "Loading...", CH: "加载中..." },
    empty: { KR: "등록된 공휴일이 없습니다. '공휴일 업데이트'를 눌러 주세요.", EN: "No holidays yet. Click 'Update Holidays'.", CH: "暂无节假日。请点击“更新节假日”。" },
    modalAdd: { KR: "공휴일 추가", EN: "Add Holiday", CH: "添加节假日" },
    modalEdit: { KR: "공휴일 수정", EN: "Edit Holiday", CH: "编辑节假日" },
    deleteConfirm: { KR: "{date} {name} 을(를) 지우시겠습니까?", EN: "Delete {date} {name}?", CH: "确定删除 {date} {name} 吗？" },
    dateRequired: { KR: "날짜를 입력하세요.", EN: "Enter a date.", CH: "请输入日期。" },
    nameRequired: { KR: "이름을 입력하세요.", EN: "Enter a name.", CH: "请输入名称。" },
    updated: { KR: "{year}년 — 새로 {added}일, 고침 {updated}일, 직접입력 지킴 {kept}일 (모두 {total}일)", EN: "{year} — {added} added, {updated} updated, {kept} manual kept ({total} total)", CH: "{year}年 — 新增 {added} 天，更新 {updated} 天，保留手动 {kept} 天（共 {total} 天）" },
    updateFailed: { KR: "받아오지 못했습니다: {msg}", EN: "Could not fetch: {msg}", CH: "获取失败：{msg}" },
    saveFailed: { KR: "저장하지 못했습니다: {msg}", EN: "Could not save: {msg}", CH: "保存失败：{msg}" },
    viewCalendar: { KR: "달력", EN: "Calendar", CH: "日历" },
    viewList: { KR: "목록", EN: "List", CH: "列表" },
    legendOff: { KR: "휴일", EN: "Day off", CH: "休假" },
    legendWork: { KR: "대체근무", EN: "Make-up workday", CH: "调休上班" },
    legendManual: { KR: "직접입력", EN: "Manual", CH: "手动" },
    clickToAdd: { KR: "날짜를 누르면 추가·수정할 수 있습니다.", EN: "Click a date to add or edit.", CH: "点击日期可添加或编辑。" },
    monthLabel: { KR: "{m}월", EN: "{m}", CH: "{m}月" },
    notYet: {
      KR: "다음 해 일정은 보통 전년 11~12월에 발표됩니다.",
      EN: "Next year's schedule is usually announced in Nov-Dec of the previous year.",
      CH: "次年安排通常在上一年11—12月公布。",
    },
  },

  deliveryMonitoring: {
    pageDesc: {
      KR: "최종승인된 발주서의 품목별로 발주 → 생산 → 선적 → 입고를 한 줄에서 봅니다. 예정일은 주말은 세고 중국 공휴일은 빼고 계산합니다.",
      EN: "One row per item of fully approved POs: order to production to shipping to receipt. Due dates count weekends but skip Chinese holidays.",
      CH: "按最终审批采购订单的物料逐行显示：下单、生产、装运、入库。预计日期计入周末，但不计中国法定节假日。",
    },
    search: { KR: "구매오더·자재코드 검색", EN: "Search PO or material code", CH: "搜索采购订单或物料编码" },
    dateField: { KR: "기준", EN: "Date basis", CH: "基准" },
    viewAll: { KR: "전체 보기", EN: "Show all", CH: "显示全部" },
    viewActive: { KR: "취소 제외", EN: "Hide cancelled", CH: "不含已取消" },
    hideReceived: { KR: "입고완료 제외", EN: "Hide received", CH: "不含已入库" },
    viewCancelled: { KR: "취소된 것만", EN: "Cancelled only", CH: "仅已取消" },
    viewHint: { KR: "제목을 눌러 취소된 건을 함께 볼 수 있습니다.", EN: "Click the header to include cancelled orders.", CH: "点击标题可一并查看已取消的订单。" },
    from: { KR: "시작일", EN: "From", CH: "开始日期" },
    to: { KR: "종료일", EN: "To", CH: "结束日期" },
    clear: { KR: "조건 지우기", EN: "Clear", CH: "清除条件" },
    syncReceipts: { KR: "입고일 수집", EN: "Sync receipts", CH: "采集入库日" },
    syncing: { KR: "수집 중...", EN: "Syncing...", CH: "采集中..." },
    syncDone: { KR: "오더 {orders}건에서 {updated}줄의 입고일을 채웠습니다.", EN: "Filled receipt dates for {updated} rows from {orders} orders.", CH: "已从 {orders} 个订单填充 {updated} 行入库日。" },
    addManual: { KR: "항목 추가", EN: "Add item", CH: "添加项目" },
    addTitle: { KR: "모니터링 항목 추가", EN: "Add an item to monitor", CH: "添加监控项目" },
    addDesc: {
      KR: "구매오더·자재코드·발주일만 넣으면 됩니다. 품명과 공급상은 자재코드 DB 에서, 수량과 취소 여부·입고일은 SAP 에서 읽어 채웁니다.",
      EN: "Enter the PO, material code and order date. Name and supplier come from the material database; quantity, cancellation and receipt date come from SAP.",
      CH: "只需填写采购订单、物料编码与下单日。品名与供应商取自物料编码库；数量、取消状态与入库日取自 SAP。",
    },
    addSapOrder: { KR: "구매오더 (SAP)", EN: "Purchase order (SAP)", CH: "采购订单（SAP）" },
    addProduct: { KR: "자재코드", EN: "Material code", CH: "物料编码" },
    addOrderDate: { KR: "발주일", EN: "Order date", CH: "下单日" },
    addSubmit: { KR: "추가", EN: "Add", CH: "添加" },
    addAdding: { KR: "읽는 중...", EN: "Reading...", CH: "读取中..." },
    addDone: { KR: "추가했습니다.", EN: "Added.", CH: "已添加。" },
    addNoMaterial: { KR: "자재코드 DB 에 없는 코드라 품명을 못 채웠습니다.", EN: "The material code was not found, so the name is empty.", CH: "物料编码库中没有该编码，品名未填充。" },
    addNoSap: { KR: "SAP 에서 이 구매오더의 해당 품목을 찾지 못해 수량이 비어 있습니다.", EN: "SAP has no such item on this order, so quantity is empty.", CH: "SAP 中未找到该订单的此物料，数量为空。" },
    addNeed: { KR: "구매오더·자재코드·발주일을 모두 넣어 주세요.", EN: "Enter the PO, material code and order date.", CH: "请填写采购订单、物料编码与下单日。" },
    manualBadge: { KR: "수동입력", EN: "Manual entry", CH: "手动录入" },
    deleteMode: { KR: "삭제", EN: "Delete", CH: "删除" },
    deleteSelected: { KR: "{n}줄 삭제", EN: "Delete {n}", CH: "删除 {n} 行" },
    deleteCancel: { KR: "선택 취소", EN: "Cancel", CH: "取消选择" },
    deleteOnlyManual: {
      KR: "수동입력한 줄만 지울 수 있습니다. 발주서에서 온 줄은 다시 읽혀 돌아옵니다.",
      EN: "Only manually added rows can be deleted; rows from purchase orders are reloaded.",
      CH: "仅可删除手动录入的行；来自采购单的行会再次载入。",
    },
    deleteSelectedConfirm: { KR: "고른 {n}줄을 지울까요?", EN: "Delete the {n} selected rows?", CH: "确定删除所选 {n} 行吗？" },
    deleteNone: { KR: "지울 줄을 고르세요. (수동입력한 줄만 고를 수 있습니다)", EN: "Select rows to delete. Only manual rows can be selected.", CH: "请选择要删除的行（仅限手动录入的行）。" },
    deleteRow: { KR: "이 줄 지우기", EN: "Delete this row", CH: "删除此行" },
    deleteConfirm: { KR: "{po} / {code} 줄을 지울까요?", EN: "Delete the row {po} / {code}?", CH: "确定删除 {po} / {code} 行吗？" },
    deleted: { KR: "지웠습니다.", EN: "Deleted.", CH: "已删除。" },
    fetchMail: { KR: "메일 가져오기", EN: "Fetch mail", CH: "收取邮件" },
    fetching: { KR: "받는 중...", EN: "Fetching...", CH: "收取中..." },
    fetchRange: { KR: "기간 지정", EN: "Date range", CH: "指定期间" },
    fetchRangeDesc: {
      KR: "비워 두면 설정의 '훑을 기간' 만큼, 이미 읽은 메일 다음부터 받습니다. 기간을 넣으면 그 기간을 다시 받습니다.",
      EN: "Leave empty to continue from the last mail read, covering the configured look-back. Enter a range to re-read that period.",
      CH: "留空则按设定的回溯天数，从上次读取之后继续。填写期间则重新收取该期间。",
    },
    poSyncTitle: { KR: "PO Management 동기화", EN: "Re-sync from PO Management", CH: "与 PO Management 同步" },
    poSyncDesc: {
      KR: "발주서가 가리키는 SAP 구매오더를 다시 받아 수량과 취소 여부를 맞춥니다. 오더가 많으면 몇 분 걸리며, 뒤에서 돌아갑니다.",
      EN: "Re-reads the SAP purchase orders referenced by the POs to refresh quantity and cancellation. It runs in the background and can take a few minutes.",
      CH: "重新读取采购单所指向的 SAP 采购订单，以更新数量与取消状态。订单较多时需要几分钟，在后台运行。",
    },
    poSyncRun: { KR: "지금 동기화", EN: "Sync now", CH: "立即同步" },
    poSyncRunning: { KR: "동기화 중...", EN: "Syncing...", CH: "同步中..." },
    poSyncStarted: { KR: "동기화를 시작했습니다. 끝나면 여기에 결과가 적힙니다.", EN: "Started. The result will appear here when it finishes.", CH: "已开始。完成后结果将显示在此处。" },
    poSyncLast: { KR: "마지막 동기화", EN: "Last sync", CH: "上次同步" },
    poSyncNever: { KR: "아직 한 번도 돌지 않았습니다", EN: "Has not run yet", CH: "尚未运行" },
    mailTitle: { KR: "메일 자동 체크", EN: "Automatic mail check", CH: "邮件自动检查" },
    mailEnabled: { KR: "자동으로 메일을 확인한다", EN: "Check mail automatically", CH: "自动检查邮件" },
    mailEnabledOff: { KR: "끄면 '메일 가져오기' 단추로만 수집합니다", EN: "when off, only the Fetch mail button collects", CH: "关闭后仅通过“收取邮件”按钮收集" },
    mailStart: { KR: "시작 시각", EN: "From", CH: "开始时间" },
    mailEnd: { KR: "종료 시각", EN: "To", CH: "结束时间" },
    mailInterval: { KR: "체크 간격(분)", EN: "Interval (min)", CH: "检查间隔（分钟）" },
    mailDays: { KR: "훑을 기간(일)", EN: "Look-back (days)", CH: "回溯天数" },
    mailHour: { KR: "{n}시", EN: "{n}:00", CH: "{n} 时" },
    mailSummary: {
      KR: "한국시간 {start}시~{end}시 사이에 {every}분마다, 최근 {days}일치 메일을 확인합니다.",
      EN: "Checks mail every {every} minutes between {start}:00 and {end}:00 KST, looking back {days} days.",
      CH: "韩国时间 {start} 时至 {end} 时之间，每 {every} 分钟检查一次，回溯最近 {days} 天的邮件。",
    },
    mailLast: { KR: "마지막 체크", EN: "Last check", CH: "上次检查" },
    mailNever: { KR: "아직 한 번도 돌지 않았습니다", EN: "Has not run yet", CH: "尚未运行" },
    fetchDone: { KR: "{summary}", EN: "{summary}", CH: "{summary}" },
    importShipping: { KR: "선적정보 업로드", EN: "Upload shipping file", CH: "上传装运信息" },
    importing: { KR: "읽는 중...", EN: "Reading...", CH: "读取中..." },
    importDesc: {
      KR: "물류업체가 보낸 엑셀을 직접 올려 채웁니다. 메일 자동 체크가 놓친 건을 메울 때 씁니다.",
      EN: "Upload the forwarder's Excel by hand. Use it to fill in what the automatic mail check missed.",
      CH: "手动上传物流公司的 Excel。用于补充邮件自动检查遗漏的内容。",
    },
    importDone: { KR: "{total}줄 중 {matched}줄을 채웠습니다.", EN: "Filled {matched} of {total} rows.", CH: "共 {total} 行，已填充 {matched} 行。" },
    importUnmatched: { KR: "매치되지 않은 {n}줄", EN: "{n} unmatched rows", CH: "{n} 行未匹配" },
    importUnmatchedDesc: {
      KR: "아래 줄은 최종승인된 발주서에서 订单号·韩国 CODE 를 찾지 못했습니다.",
      EN: "No fully approved PO item was found for the order number and material code below.",
      CH: "下列行未在最终审批的采购订单中找到订单号与韩国 CODE。",
    },
    settings: { KR: "설정", EN: "Settings", CH: "设置" },
    settingsTitle: { KR: "물류업체 발신인", EN: "Forwarder senders", CH: "物流公司发件人" },
    syncTitle: { KR: "입고일 자동 수집", EN: "Auto-sync receipt dates", CH: "自动采集入库日" },
    syncEnabled: { KR: "자동으로 받아 오기", EN: "Collect automatically", CH: "自动采集" },
    syncEvery: { KR: "주기", EN: "Every", CH: "周期" },
    syncHours: { KR: "{n}시간", EN: "{n} h", CH: "{n} 小时" },
    syncLast: { KR: "마지막 수집: {at}", EN: "Last run: {at}", CH: "上次采集：{at}" },
    syncNever: { KR: "아직 받아 온 적이 없습니다.", EN: "Never run yet.", CH: "尚未采集过。" },
    syncDesc: {
      KR: "켜 두면 설정한 주기마다 SAP 에서 입고일을 받아 채웁니다. 이미 입고된 건도 함께 채워집니다.",
      EN: "When on, receipt dates are pulled from SAP at the chosen interval, including already-received items.",
      CH: "开启后将按设定周期从 SAP 采集入库日，已入库的物料也会一并填充。",
    },
    settingsDesc: {
      KR: "출항·도착예정일과 선명·항차번호를 읽어 올 메일의 발신인 주소입니다. 등록한 주소에서 온 메일만 검색합니다.",
      EN: "Sender addresses of the mails that carry ETD/ETA, vessel and voyage. Only mail from these addresses is searched.",
      CH: "用于读取离港、到港日期及船名、航次的邮件发件人地址。仅检索来自这些地址的邮件。",
    },
    senderAdd: { KR: "추가", EN: "Add", CH: "添加" },
    senderNone: { KR: "등록된 발신인이 없습니다.", EN: "No senders registered.", CH: "尚未登记发件人。" },
    senderRemove: { KR: "빼기", EN: "Remove", CH: "移除" },
    senderDup: { KR: "이미 등록된 주소입니다.", EN: "Already registered.", CH: "该地址已登记。" },
    save: { KR: "저장", EN: "Save", CH: "保存" },
    saved: { KR: "저장했습니다.", EN: "Saved.", CH: "已保存。" },
    close: { KR: "닫기", EN: "Close", CH: "关闭" },
    excelDownload: { KR: "엑셀", EN: "Excel", CH: "Excel" },
    excelNothing: { KR: "내려받을 줄이 없습니다.", EN: "Nothing to download.", CH: "没有可下载的行。" },
    excelDone: { KR: "{n}줄을 내려받았습니다.", EN: "Downloaded {n} rows.", CH: "已下载 {n} 行。" },
    statsButton: { KR: "통계", EN: "Statistics", CH: "统计" },
    statsTitle: { KR: "납기 통계", EN: "Lead time statistics", CH: "交期统计" },
    statsDesc: {
      KR: "입고까지 끝난 건만 셉니다. 지금 화면에 걸린 검색·기간·취소 조건을 그대로 따릅니다.",
      EN: "Counts only items already received, following the search, period and cancellation filters currently applied.",
      CH: "仅统计已入库的物料，并沿用当前的搜索、期间与取消筛选条件。",
    },
    statsHolidayMode: { KR: "중국 공휴일", EN: "Chinese holidays", CH: "中国节假日" },
    statsHolidayIn: { KR: "포함", EN: "Included", CH: "计入" },
    statsHolidayOut: { KR: "제외", EN: "Excluded", CH: "不计" },
    statsEmpty: { KR: "입고일이 있는 건이 없습니다.", EN: "No received items to count.", CH: "没有已入库的记录。" },
    statsCount: { KR: "대상 {n}줄", EN: "{n} rows", CH: "{n} 行" },
    statsAdjusted: {
      KR: "{n}줄은 커터치↔커이로 다시 끊은 건이라, 취소된 원래 구매오더의 발주일로 다시 셌습니다.",
      EN: "{n} rows were re-issued between Kuttouch and Keyi, so they are counted from the cancelled original order's date.",
      CH: "{n} 行为科特琪与科易之间重新下单，因此按已取消的原采购订单日期重新计算。",
    },
    statsAdjustedRow: { KR: "{code} · 오더 {id} → 원본 {origin}({date}) · {before}일 → {after}일", EN: "{code} · order {id} → origin {origin} ({date}) · {before} → {after} days", CH: "{code} · 订单 {id} → 原单 {origin}（{date}）· {before} 天 → {after} 天" },
    statsExcluded: {
      KR: "발주일부터 입고일까지 5일 이내이면서 원래 구매오더를 못 찾은 {n}줄은 뺐습니다 — 이미 들어와 있던 물건을 뒤늦게 발주로 맞춘 건으로 봅니다.",
      EN: "{n} rows received within 5 days of the order date were left out — those are stock already on hand, matched to an order afterwards.",
      CH: "已排除下单后 5 天内入库的 {n} 行 —— 视为先到货、后补下单的情况。",
    },
    statsSpan: { KR: "구간", EN: "Stage", CH: "区间" },
    statsN: { KR: "건수", EN: "Count", CH: "件数" },
    statsAvg: { KR: "평균", EN: "Average", CH: "平均" },
    statsMedian: { KR: "중앙값", EN: "Median", CH: "中位数" },
    statsMin: { KR: "최소", EN: "Min", CH: "最小" },
    statsMax: { KR: "최대", EN: "Max", CH: "最大" },
    statsDist: { KR: "실제납기일 분포", EN: "Actual lead time distribution", CH: "实际交期分布" },
    statsOver: { KR: "55일을 넘은 건 {n}줄 ({p}%)", EN: "{n} rows ({p}%) took more than 55 days", CH: "超过 55 天的有 {n} 行（{p}%）" },
    statsBand50: { KR: "50일 이하", EN: "50 days or less", CH: "50 天以内" },
    statsBand55: { KR: "51~55일", EN: "51-55 days", CH: "51~55 天" },
    statsBand60: { KR: "56~60일", EN: "56-60 days", CH: "56~60 天" },
    statsBand61: { KR: "61일 이상", EN: "61 days or more", CH: "61 天以上" },
    historyTitle: { KR: "변경이력", EN: "Change history", CH: "变更记录" },
    historyEmpty: { KR: "아직 바뀐 적이 없습니다.", EN: "Nothing has changed yet.", CH: "尚无变更。" },
    historyLoading: { KR: "불러오는 중...", EN: "Loading...", CH: "加载中..." },
    historyFrom: { KR: "비어 있음", EN: "empty", CH: "空" },
    srcManual: { KR: "직접 입력", EN: "By hand", CH: "手动" },
    srcMail: { KR: "선적정보", EN: "Shipping file", CH: "装运信息" },
    srcSap: { KR: "SAP", EN: "SAP", CH: "SAP" },
    materialTitle: { KR: "자재 정보", EN: "Material", CH: "物料信息" },
    orderTitle: { KR: "구매오더", EN: "Purchase order", CH: "采购订单" },
    lookupLoading: { KR: "불러오는 중...", EN: "Loading...", CH: "加载中..." },
    lookupNone: { KR: "자재코드 DB 에 없는 코드입니다.", EN: "Not found in the material database.", CH: "物料编码库中没有该编码。" },
    lookupNoOrder: { KR: "구매오더수신 DB 에 아직 없는 오더입니다.", EN: "This order is not in the purchase-order database yet.", CH: "采购订单库中尚无该订单。" },
    mCategory: { KR: "분류", EN: "Category", CH: "分类" },
    mHqName: { KR: "본사제품명", EN: "HQ name", CH: "本社品名" },
    mSapName: { KR: "SAP 제품명", EN: "SAP name", CH: "SAP 品名" },
    mChinaCode: { KR: "중국코드", EN: "China code", CH: "中国编码" },
    mChinaName: { KR: "중국제품명", EN: "China name", CH: "中国品名" },
    mSpec: { KR: "규격", EN: "Spec", CH: "规格" },
    mExportPrice: { KR: "수출단가", EN: "Export price", CH: "出口单价" },
    mExportPriceCny: { KR: "수출단가(위안)", EN: "Export price (CNY)", CH: "出口单价（元）" },
    mVatPrice: { KR: "증치세포함가", EN: "Price incl. VAT", CH: "含税价" },
    mSupplier: { KR: "공급상", EN: "Supplier", CH: "供应商" },
    mNoImage: { KR: "등록된 사진이 없습니다.", EN: "No photo registered.", CH: "未登记照片。" },
    mPhotoZoom: { KR: "누르면 원본 크기로 봅니다", EN: "Click to view full size", CH: "点击查看原图" },
    oOrderDate: { KR: "발주일(SAP)", EN: "Order date (SAP)", CH: "下单日（SAP）" },
    oVendor: { KR: "공급업체", EN: "Vendor", CH: "供货公司" },
    oAmount: { KR: "금액", EN: "Amount", CH: "金额" },
    oItems: { KR: "품목 {n}줄", EN: "{n} items", CH: "{n} 项物料" },
    oItemNo: { KR: "항번", EN: "No", CH: "项次" },
    oDue: { KR: "요청납기", EN: "Requested", CH: "要求交期" },
    oShippedLegend: { KR: "선적된 품목", EN: "Shipped items", CH: "已装船品目" },
    oReceivedLegend: { KR: "입고된 품목", EN: "Received items", CH: "已入库品目" },
    oShipEtd: { KR: "ETD", EN: "ETD", CH: "ETD" },
    oShipVessel: { KR: "선명", EN: "Vessel", CH: "船名" },
    oShipVoyage: { KR: "항차번호", EN: "Voyage", CH: "航次" },
    oShipReceipt: { KR: "입고일", EN: "Received", CH: "入库日" },
    oUnitPrice: { KR: "단가", EN: "Unit price", CH: "单价" },
    detailTitle: { KR: "상세정보", EN: "Details", CH: "详细信息" },
    detailDueHint: {
      KR: "비우면 발주일 + 35일(공휴일 제외)로 다시 계산합니다. 계산값은 {date} 입니다.",
      EN: "Leave empty to recalculate as order date + 35 days (holidays excluded). Calculated: {date}.",
      CH: "留空则按下单日 + 35 天（不含节假日）重新计算。计算值：{date}。",
    },
    detailCalculated: { KR: "계산값", EN: "Calculated", CH: "计算值" },
    detailOverridden: { KR: "직접 입력", EN: "Manual", CH: "手动输入" },
    cfSortAsc: { KR: "오름차순", EN: "Sort A-Z", CH: "升序" },
    cfSortDesc: { KR: "내림차순", EN: "Sort Z-A", CH: "降序" },
    cfAll: { KR: "전체선택", EN: "Select all", CH: "全选" },
    cfNone: { KR: "모두해제", EN: "Clear", CH: "全不选" },
    cfEmpty: { KR: "(빈 값)", EN: "(blank)", CH: "（空白）" },
    cfSearch: { KR: "값 찾기", EN: "Search values", CH: "查找值" },
    cfCount: { KR: "{n}개 선택", EN: "{n} selected", CH: "已选 {n} 项" },
    colPick: { KR: "컬럼", EN: "Columns", CH: "列" },
    colPickHidden: { KR: "{n} 숨김", EN: "{n} hidden", CH: "隐藏 {n}" },
    colPickAll: { KR: "전체선택", EN: "Select all", CH: "全选" },
    colPickReset: { KR: "기본값", EN: "Default", CH: "默认" },
    colPickHint: { KR: "끌어서 순서를 바꿉니다.", EN: "Drag to reorder.", CH: "拖动可调整顺序。" },
    colPo: { KR: "구매오더", EN: "PO", CH: "采购订单" },
    colStatus: { KR: "상태", EN: "Status", CH: "状态" },
    statusCancelled: { KR: "취소", EN: "Cancelled", CH: "已取消" },
    statusNormal: { KR: "정상", EN: "Active", CH: "正常" },
    statusReissued: { KR: "재발주", EN: "Re-issued", CH: "重新下单" },
    splitBadge: { KR: "분할선적", EN: "Split", CH: "分批出运" },
    splitTitle: { KR: "분할 선적", EN: "Split shipment", CH: "分批出运" },
    splitHint: { KR: "같은 구매오더·자재를 다른 배(선명·항차)로 나눠 실은 건입니다. 본 줄과 따로 추적합니다.", EN: "Part of the same order/material shipped on a different vessel/voyage. Tracked separately from the main line.", CH: "同一订单、同一物料分船（船名·航次不同）出运，与主行分开跟踪。" },
    splitQty: { KR: "수량", EN: "Qty", CH: "数量" },
    splitSave: { KR: "저장", EN: "Save", CH: "保存" },
    splitClose: { KR: "닫기", EN: "Close", CH: "关闭" },
    splitDelete: { KR: "이 줄 삭제", EN: "Delete this line", CH: "删除此行" },
    splitDeleteConfirm: { KR: "이 분할 선적 줄을 지울까요?", EN: "Delete this split shipment line?", CH: "确定删除此分批出运行吗？" },
    splitSaved: { KR: "저장했습니다.", EN: "Saved.", CH: "已保存。" },
    splitDeleted: { KR: "지웠습니다.", EN: "Deleted.", CH: "已删除。" },
    splitShipLog: { KR: "분할 선적 추가", EN: "Split shipment added", CH: "新增分批出运" },
    notifyTitle: { KR: "영업사원 이메일 통지", EN: "Sales rep email notification", CH: "销售人员邮件通知" },
    notifyDesc: { KR: "줄의 값(생산예정·완료일, ETD·ETA, 선명·항차, INVOICE, 입고일, 분할 선적, 특이사항)이 바뀌면 그 품목이 걸린 판매오더의 책임자에게 하루 한 번 아침 8시(한국시간)에 전날부터 바뀐 것만 모아 메일로 알립니다. 받는 사람은 사용자 목록에서 먼저 찾고, 없으면 직원 명부에서 찾습니다.", EN: "When a line changes (production dates, ETD/ETA, vessel/voyage, invoice, receipt date, split shipment, remarks), the person responsible for the related sales order is emailed one daily digest at 8:00 AM (KST) with only what changed. Recipients are looked up in the user list first, then in the employee register.", CH: "行数据（生产日期、ETD·ETA、船名·航次、INVOICE、入库日、分批出运、特殊事项）发生变化时，每天早上8点（韩国时间）汇总前一天以来的变更，发邮件通知相关销售订单的负责人。收件人先在用户列表中查找，找不到再查员工名册。" },
    notifyEnabled: { KR: "영업사원(판매오더 담당자)에게 변경 내용 이메일로 알리기", EN: "Email changes to the sales rep (sales order owner)", CH: "通过邮件通知销售人员（销售订单负责人）变更内容" },
    notifyLast: { KR: "마지막 확인: {at}", EN: "Last run: {at}", CH: "最近执行：{at}" },
    notifyNever: { KR: "아직 보낸 적 없음", EN: "Not run yet", CH: "尚未执行" },
    reissueHint: { KR: "중국커터치 오더 {from}이 취소되고 같은 품목·수량을 중국커이 오더 {to}({date} 발주)로 다시 끊었습니다. 일정은 {from} 기준으로 세고, 입고일만 {to}의 입고일({receipt})을 씁니다.", EN: "Kuttouch order {from} was cancelled and the same items/qty were re-ordered from Keyi as {to} (ordered {date}). The schedule counts from {from}; only the receipt date ({receipt}) comes from {to}.", CH: "中国科特琪订单 {from} 已取消，相同物料与数量改由中国科毅订单 {to}（{date} 下单）重新下单。交期按 {from} 计算，仅入库日（{receipt}）采用 {to} 的入库日。" },
    colPoDoc: { KR: "발주서번호", EN: "PO document", CH: "采购单号" },
    colSupplier: { KR: "공급상", EN: "Supplier", CH: "供应商" },
    colSapSupplier: { KR: "공급업체", EN: "Vendor", CH: "供货公司" },
    colProduct: { KR: "자재코드", EN: "Material", CH: "物料编码" },
    colName: { KR: "품명", EN: "Description", CH: "品名" },
    colSapName: { KR: "SAP 제품명", EN: "SAP name", CH: "SAP 品名" },
    colSalesOrder: { KR: "판매오더", EN: "Sales order", CH: "销售订单" },
    colSoOwner: { KR: "판매오더 담당자", EN: "SO owner", CH: "销售订单负责人" },
    colQty: { KR: "수량", EN: "Qty", CH: "数量" },
    originHint: {
      KR: "품목·수량이 똑같은 취소 오더 {id}({date})가 있습니다 — 다시 끊은 건으로 보입니다. 목록의 발주일은 그대로 두고, 통계에서만 이 날로 셉니다(커터치↔커이로 바뀌고 닷새 안에 입고된 건).",
      EN: "Cancelled order {id} ({date}) has the same items and quantities — this looks like a re-issue. The list keeps its own order date; statistics count from that date only for Kuttouch/Keyi switches received within five days.",
      CH: "存在品目与数量完全一致的已取消订单 {id}（{date}），应为重新下单。列表仍显示本订单的下单日；仅在科特琪与科易互换且五天内入库时，统计按该日期计算。",
    },
    originBadge: { KR: "원발주 {id}", EN: "From {id}", CH: "源自 {id}" },
    colOrderDate: { KR: "발주일", EN: "Order date", CH: "下单日" },
    colProductionDue: { KR: "생산예정일", EN: "Production due", CH: "预计生产完成日" },
    colProductionDone: { KR: "생산완료일", EN: "Production done", CH: "实际生产完成日" },
    colInvoice: { KR: "INVOICE", EN: "Invoice", CH: "发票号" },
    colVessel: { KR: "선명", EN: "Vessel", CH: "船名" },
    colVoyage: { KR: "항차번호", EN: "Voyage", CH: "航次" },
    colEtd: { KR: "출항예정일", EN: "ETD", CH: "预计离港日" },
    colEta: { KR: "도착예정일", EN: "ETA", CH: "预计到港日" },
    colReceipt: { KR: "입고일", EN: "Receipt date", CH: "入库日" },
    colTotalDue: { KR: "예상입고일", EN: "Expected receipt", CH: "预计入库日" },
    colLeadActual: { KR: "실제납기일", EN: "Actual lead", CH: "实际交期" },
    colLeadProduction: { KR: "생산완료납기일", EN: "To production", CH: "至生产完成" },
    colLeadShipping: { KR: "선적납기일", EN: "To departure", CH: "至离港" },
    colLeadInbound: { KR: "입고납기일", EN: "To receipt", CH: "至入库" },
    leadDays: { KR: "{n}일", EN: "{n} d", CH: "{n} 天" },
    leadActualHint: { KR: "발주일부터 입고일까지 {n}일 (그중 중국 공휴일 {h}일)", EN: "{n} days from order to receipt ({h} Chinese holidays)", CH: "下单至入库 {n} 天（其中中国节假日 {h} 天）" },
    leadProductionHint: { KR: "발주일부터 생산완료일까지 {n}일 (그중 중국 공휴일 {h}일)", EN: "{n} days from order to production done ({h} Chinese holidays)", CH: "下单至生产完成 {n} 天（其中中国节假日 {h} 天）" },
    leadShippingHint: { KR: "생산완료일부터 출항일까지 {n}일", EN: "{n} days from production done to departure", CH: "生产完成至离港 {n} 天" },
    leadInboundHint: { KR: "출항일부터 입고일까지 {n}일", EN: "{n} days from departure to receipt", CH: "离港至入库 {n} 天" },
    calcLead: {
      KR: "납기일 컬럼은 실제로 흘러간 달력 일수입니다 — 예정일과 달리 공휴일을 빼지 않습니다. 실제납기일·생산완료납기일에는 그 사이에 낀 연휴가 며칠인지 함께 보여줍니다.",
      EN: "The lead-time columns count actual calendar days and, unlike the due dates, do not skip holidays. For the first two, the number of Chinese holidays in between is shown as well.",
      CH: "交期列按实际日历天数计算，与预计日期不同，不扣除节假日。前两项还会显示期间包含的中国节假日天数。",
    },
    colNote: { KR: "특이사항", EN: "Remarks", CH: "特殊事项" },
    basisOrder: { KR: "발주일", EN: "Order date", CH: "下单日" },
    basisProduction: { KR: "생산예정일", EN: "Production due", CH: "预计生产完成日" },
    basisDone: { KR: "생산완료일", EN: "Production done", CH: "实际生产完成日" },
    basisEtd: { KR: "출항예정일", EN: "ETD", CH: "预计离港日" },
    basisEta: { KR: "도착예정일", EN: "ETA", CH: "预计到港日" },
    basisReceipt: { KR: "입고일", EN: "Receipt date", CH: "入库日" },
    basisExpected: { KR: "예상입고일", EN: "Expected receipt", CH: "预计入库日" },
    expectedFromEtd: { KR: "ETD({date}) + 6~7일로 잡았습니다.", EN: "Set to ETD ({date}) + 6-7 days.", CH: "按 ETD（{date}）+ 6~7 天计算。" },
    expectedFromDone: { KR: "생산이 예정보다 {n}일 늦어 그만큼 밀었습니다.", EN: "Production finished {n} days late, so it is pushed out by the same amount.", CH: "生产比计划晚 {n} 天，因此相应顺延。" },
    expectedFromDoneEarly: { KR: "생산이 예정보다 {n}일 일러 그만큼 당겼습니다.", EN: "Production finished {n} days early, so it is pulled in by the same amount.", CH: "生产比计划早 {n} 天，因此相应提前。" },
    expectedFromOrder: { KR: "발주일 + 50~55일(공휴일 제외)에 하루를 더한 값입니다.", EN: "Order date + 50-55 days (holidays excluded) plus 1 day.", CH: "按下单日 + 50~55 天（不含节假日）再加 1 天计算。" },
    calcTitle: { KR: "날짜는 이렇게 셉니다", EN: "How the dates are calculated", CH: "日期计算方式" },
    calcProduction: {
      KR: "생산예정일 = 발주일 + 35일. 발주일은 발주서가 2차(최종) 결재된 날입니다.",
      EN: "Production due = order date + 35 days. The order date is when the PO got its final approval.",
      CH: "预计生产完成日 = 下单日 + 35 天。下单日为采购单取得最终审批的日期。",
    },
    calcTotal: {
      KR: "예상입고일 = 발주일 + 50~55일 + 1일. 생산 35일에 선적·운송·통관에 걸리는 15~20일을 더하고, 입고 처리에 하루를 더 둔 범위입니다.",
      EN: "Expected receipt = order date + 50-55 days + 1 day: 35 days of production, 15-20 days for shipping, transit and customs, plus a day for receiving.",
      CH: "预计入库日 = 下单日 + 50~55 天 + 1 天：生产 35 天，加上装运、运输与清关的 15~20 天，再加 1 天入库处理。",
    },
    calcExpected: {
      KR: "실제 값이 들어오면 예상입고일이 바뀝니다 — 생산완료일을 넣으면 생산예정일과의 차이만큼 밀거나 당기고, ETD 가 들어오면 ETD + 6~7일로 잡습니다(ETD 가 우선).",
      EN: "Actual values move the expected receipt: entering the production-done date shifts it by the gap from the production due date, and an ETD sets it to ETD + 6-7 days (ETD wins).",
      CH: "实际数据会调整预计入库日：填写实际生产完成日后，按与预计生产完成日的差值顺延或提前；出现 ETD 后，则按 ETD + 6~7 天计算（ETD 优先）。",
    },
    calcHoliday: {
      KR: "세는 방법은 둘 다 같습니다 — 토·일은 세고, 중국 법정공휴일은 세지 않습니다. 중국 공장은 주말에도 돌지만 법정 연휴에는 멈추기 때문입니다. 공휴일은 Holiday 메뉴의 목록을 그대로 씁니다.",
      EN: "Both count the same way: weekends count, Chinese public holidays do not. Factories there run on weekends but stop for statutory holidays. The holidays come from the Holiday menu.",
      CH: "两者计算方式相同：计入周末，不计中国法定节假日。当地工厂周末照常生产，但法定假期停工。节假日取自“中国节假日”菜单。",
    },
    holidayPushed: { KR: "{list} 때문에 {n}일 밀렸습니다.", EN: "Pushed out {n} days by {list}.", CH: "因{list}顺延 {n} 天。" },
    holidayNone: { KR: "걸린 공휴일이 없습니다.", EN: "No holidays in this window.", CH: "期间无节假日。" },
    calcOverride: {
      KR: "생산예정일은 행을 눌러 직접 넣을 수 있습니다. 넣으면 그 값이 우선하고, 비우면 다시 위 방식으로 계산합니다.",
      EN: "The production due date can be entered by hand from the row's detail. A manual value wins; clearing it brings the calculation back.",
      CH: "可在行详情中手动输入预计生产完成日。手动值优先；清空后将恢复按上述方式计算。",
    },
    count: { KR: "{n}줄", EN: "{n} rows", CH: "{n} 行" },
    loading: { KR: "불러오는 중...", EN: "Loading...", CH: "加载中..." },
    empty: { KR: "최종승인된 발주서가 없습니다.", EN: "No fully approved purchase orders.", CH: "暂无最终审批的采购订单。" },
    emptyFiltered: { KR: "조건에 맞는 줄이 없습니다.", EN: "No rows match the filter.", CH: "没有符合条件的行。" },
    missingHolidayYears: {
      KR: "{years}년 공휴일이 등록되어 있지 않아 그 해로 떨어지는 예정일은 연휴가 빠지지 않았습니다. Holiday 메뉴에서 받아 오세요.",
      EN: "Holidays for {years} are not registered, so due dates landing in those years do not skip holidays. Load them from the Holiday menu.",
      CH: "尚未登记 {years} 年的节假日，落在该年的预计日期未扣除假期。请在中国节假日菜单中获取。",
    },
    noHolidays: {
      KR: "중국 공휴일이 등록되어 있지 않아 예정일에 연휴가 반영되지 않았습니다. Holiday 메뉴에서 받아 오세요.",
      EN: "No Chinese holidays registered, so due dates ignore holidays. Load them from the Holiday menu.",
      CH: "尚未登记中国节假日，预计日期未扣除假期。请在中国节假日菜单中获取。",
    },
  },
};

// 기본 언어
export const defaultLocale = 'KR';

// 지원 언어 목록
export const supportedLocales = ['KR', 'EN', 'CH'];
